<template>
    <div>
        <login-dialog v-if="loginDailogShow" @hide="loginDailogClick" />
        <div class="top" :style="{'height':tabIndex==0?'74px':'32px'}">
            <div class="topSubP" ref="topSubP">
                <div class="topSub">
                    <div class="topLLP">
                        <div :class="tabIndex==0 && !xiaoguanShow ? 'topLLItem topLLItemSel' : 'topLLItem'" @click="tabClick(0)">
                            <span>共享话术</span>
                            <div v-if="tabIndex==0 && !xiaoguanShow"></div>
                        </div>
                        <div class="topLLItemLine"></div>
                        <div :class="tabIndex==1 && !xiaoguanShow ? 'topLLItem topLLItemSel' : 'topLLItem'"
                            @click="tabClick(1)">
                            <span>文案库</span>
                            <div v-if="tabIndex==1 && !xiaoguanShow"></div>
                        </div>
                        <div class="topLLItemLine"></div>
                        <div :class="xiaoguanShow ? 'topLLItem topLLItemSel' : 'topLLItem'"
                            @click="toggleXiaoguanKeyboard">
                            <span>销冠键盘</span>
                            <div v-if="xiaoguanShow"></div>
                        </div>
                    </div>
                    <div class="topRP">
                        <div v-if="tabIndex==0&&huashuTeamList.length" class="topL">
                            <img v-if="huashuTeamList[teamSelIdx].roleId==2" class="topLL"
                                src="https://imagessl.edujia.com/A-1ed71af7_20230804094647.png">
                            <div class="topLR">{{huashuTeamList[teamSelIdx].showName}}</div>
                        </div>
                        <div v-else-if="tabIndex==1&&themeList.length" class="topL">
                            <div class="topLR">{{themeList[themeSelIdx].title}}</div>
                        </div>
                        <div class="topRP">
                            <div class="topR">
                                <img v-if="tabIndex==0" class="topRL" src="https://imagessl.edujia.com/A-1ed71af7_20230804095245.png" @click="changeTeam">
                                <img v-else-if="tabIndex==1" class="topRL" src="https://imagessl.edujia.com/A-1ed71af7_20230804095245.png" @click="changeTeam">
                                <div v-if="tabIndex==0" class="topRR" @click="changeTeam">切换团队</div>
                                <div v-else-if="tabIndex==1" class="topRR" @click="changeTeam">切换文案包</div>
                            </div>
                            <div class="topLLItemLine"></div>
                            <div class="topRR2" @click="loginDailogClick" >
                                <img v-if="faceIcon&&faceIcon.length" class="header-main-top" :src="faceIcon"/>
                                <img v-else class="header-main-top"
                                    src="https://imagessl.edujia.com/A-1ed71af7_20230804094317.png"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="tabIndex===0" class="searchArea">
                <img v-if="isSeaching" class="searchBackBtn" src="https://imagessl.edujia.com/A-1ed71af7_20230804162525.png"  @click="cancelSearch"/>
                <div class="searchAreaBar">
                    <img src="https://imagessl.edujia.com/A-1ed71af7_20240219112835.png" />
                    <input v-model="keywords" placeholder="输入关键词搜索" type="text" />
                </div>
                <div class="searchAreaBtn" @click="searchBtnClick">搜索</div>
                <!-- <div v-if="!isSeaching" class="searchAreaBtn" @click="searchBtnClick">搜索</div> -->
                <!-- <div v-else class="searchAreaBtn searchAreaCancelBtn" @click="searchBtnClick">取消</div> -->
            </div>
        </div>
        <div v-if="teamListShow" class="teamListCover">
            <div class="teamListP">
                <div v-if="tabIndex==0" class="teamList">
                    <div v-for="(item,idx) in huashuTeamList"
                        :key="'huashuTeamListItem'+idx"
                        :class="idx==teamSelIdx?'teamListItemSel teamListItem':'teamListItem'"
                        @click="teamItemClick(idx)">
                        <img v-if="item.roleId==1" src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png" />
                        <img v-else-if="item.roleId==2"
                            src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png" />
                        <div>{{item.showName}}</div>
                    </div>
                </div>
                <div v-else-if="tabIndex==1" class="teamList">
                    <div v-for="(item,idx) in themeList"
                        :key="'themeListItem'+idx"
                        :class="idx==themeSelIdx?'teamListItemSel teamListItem':'teamListItem'"
                        @click="themeItemClick(idx)">
                        <!-- <img v-if="item.roleId==1" src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"/>
                        <img v-else-if="item.roleId==2" src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png"/> -->
                        <div>{{item.title}}</div>
                    </div>
                </div>
            </div>
            <div class="shouqiBtnP">
                <div class="shouqiBtn" @click="hideTeamList">收起<img
                        src="https://imagessl.edujia.com/A-1ed71af7_20230807152925.png" /></div>
            </div>
        </div>
        <div v-if="xiaoguanShow" class="teamListCover xiaoguanKeyboardCover">
            <div class="xkTopBar">
                <div class="xkInputP" v-if="xkSegmentTab === 0">
                    <input class="xkInput" type="text" placeholder="点击粘贴问题"
                        v-model="xiaoguanQuestion" @click="pasteQuestionFromClipboard" />
                </div>
                <div class="xkInputP xkInputHint" v-else>
                    <span>选择下方场景，生成开场白</span>
                </div>
                <div class="xkCheckboxP">
                    <div :class="['xkCheckboxItem', xkSelProduct ? 'xkCheckboxItemSel' : '']" @click="openProductDialog">
                        <span>{{ xkSelProduct || '切换产品' }}</span>
                        <img class="xkArrowIcon" src="https://imagessl.edujia.com/A-1ed71af7_20230807152925.png" />
                    </div>
                    <div :class="['xkCheckboxItem', xkSelTeamIdx >= 0 ? 'xkCheckboxItemSel' : '']" @click="openHuashuSelectDialog" v-if="xkSegmentTab === 0">
                        <span>{{ xkSelTeamIdx >= 0 ? huashuTeamList[xkSelTeamIdx].showName : '话术选择' }}</span>
                        <img class="xkArrowIcon" src="https://imagessl.edujia.com/A-1ed71af7_20230807152925.png" />
                    </div>
                </div>
            </div>
            <div class="xkSegmentBar">
                <div :class="['xkSegmentTab', xkSegmentTab===0 ? 'xkSegmentTabSel' : '']"
                    @click="xkSegmentTab = 0; xkCategorySelIdx = -1">销冠帮回</div>
                <div :class="['xkSegmentTab', xkSegmentTab===1 ? 'xkSegmentTabSel' : '']"
                    @click="xkSegmentTab = 1; xkCategorySelIdx = -1">开场白</div>
            </div>
            <div class="teamListP">
                <div class="teamList xkCategoryList">
                    <div v-for="(item,idx) in xkCurrentCategoryList" :key="'xkCategory'+idx"
                        :class="idx==xkCategorySelIdx?'teamListItemSel teamListItem xkCategoryItem':'teamListItem xkCategoryItem'"
                        @click="xkCategoryClick(idx)">
                        <div>{{item.label}}</div>
                    </div>
                </div>
            </div>
            <div v-if="xkCategoryLoading" class="xkLoadingMask">
                <div class="xkLoadingCard">
                    <div class="xkLoadingSpinner"></div>
                    <div class="xkLoadingText">AI 正在生成回复...</div>
                    <div class="xkLoadingSub">请耐心等待，不要关闭窗口</div>
                </div>
            </div>
        </div>
        <div class="content" :style="{'padding-top':tabIndex==0?'125px':'83px'}">
            <div v-if="isSeaching" class="searchingBar">
                <img v-if="showAiSwitch" class="searchingBarIcon" src="https://imagessl.lingtuo.cn/A-1ed71af7_20241023111358.png" />
                <el-switch v-if="showAiSwitch" v-model="isAISearch" active-color="#FB5D5C" ></el-switch>
                <div v-if="(isAISearch&&huashuTeamList[teamSelIdx].roleId==2)||(huashuTeamList&&huashuTeamList[teamSelIdx].isOpenAiRec)" :style="{'margin-left':'32px'}">
                    <el-radio-group v-model="aiSearchType">
                        <el-radio :label="1">关键词搜索</el-radio>
                        <el-radio :label="2">AI搜索</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <multipane class="custom-resizer" layout="vertical" @paneResizeStop="paneresizestop">
                <div v-if="!isSeaching" class="typeList" ref="typeList"
                    :style="{'width':typeListWidth+'px','height':contentHeight+'px'}" @scroll="typeOnScroll">
                    <div v-if="tabIndex==0" @scroll="typeOnScroll">
                        <div v-for="(item,idx) in typeList"
                            :class="typeSelIdx==idx?'typeListItemSel typeListItem':'typeListItem'"
                            :key="'huashuType'+idx" @click="huashuClick(idx)"
                            @contextmenu.prevent="showTypeMenu($event,item,idx)">
                            <div>{{item.labelName}}</div>
                        </div>
                    </div>
                    <div v-else-if="tabIndex==1" @scroll="typeOnScroll">
                        <div v-for="(item,idx) in themeCategoryList"
                            :class="themeCategorySelIdx==idx?'typeListItemSel typeListItem':'typeListItem'"
                            :key="'wenanType'+idx" @click="wenanCategoryClick(idx)">
                            <div>{{item.labelName}}</div>
                        </div>
                    </div>
                </div>
                <multipane-resizer v-if="!isSeaching">
                    <div class="sizeBtn">
                        <div></div>
                        <div></div>
                    </div>
                </multipane-resizer>
                <div class="huashuList" ref="huashuList"
                    :style="{'height':contentHeight+'px','padding-top':(countTopHuashu>0&&tabIndex==0)||isSeaching?'32px':0,'margin-top':'-1px'}"
                    @scroll="huashuOnScroll">
                    <div v-if="tabIndex==0" :style="{'padding-bottom':countTopHuashu>0?'32px':0}" @mouseleave="huashuListMouseleave">
                        <div v-if="countTopHuashu&&!isSeaching" class="topBar" @click="openTopHuashu">
                            <div class="topBarL">
                                <img src="https://imagessl.lingtuo.cn/A-1ed71af7_20240705101043.png" />{{countTopHuashu}}条置顶内容
                            </div>
                            <img v-if="!huashuTopBarShow" class="topBarR"
                                src="https://imagessl.lingtuo.cn/A-1ed71af7_20240705101203.png" />
                            <img v-else class="topBarR"
                                src="https://imagessl.lingtuo.cn/A-1ed71af7_20240708100936.png" />
                        </div>
                        <div v-for="(item,idx) in showHuashuList" class="huashuListItem" @mouseenter="huashuItemMouseIn($event,item,idx)" @mouseover="huashuItemHover($event,item,idx)" @mouseleave="huashuItemMouseleave" :key="'showHuashuList'+item.id+idx"
                        :style="{'background-color':getHuashuItemBgColor(item,idx),'border-bottom':isSeaching?'1px solid #eee':0}"
                        @contextmenu.prevent="showMenu($event,item,idx)">
                        <!-- <div v-for="(item,idx) in showHuashuList" class="huashuListItem" @mouseover="huashuItemHover($event,item)" :key="'showHuashuList'+item.id+idx"
                        :style="{'background-color':item.isTop?'#eee':'#fff'}"
                        @contextmenu.prevent="showMenu($event,item,idx)"> -->
                            <div v-if="item.title" class="huashuListItemTop">
                                <img v-if="false" class="huashuListItemTopL"
                                    src="https://imagessl.edujia.com/A-1ed71af7_20230804141027.png">
                                <img v-if="item.imglist&&item.imglist.length" class="huashuListItemTopR"
                                    src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png"
                                    @click="go2ImageList(idx)">
                                <img v-else-if="item.filelist&&item.filelist.length" class="huashuListItemTopR"
                                    src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png"
                                    @click="go2ImageList(idx)">
                                <div class="huashuListItemTopM" :style="{'color':titleColor}">{{item.title}}</div>
                            </div>
                            <div :ref="item.id" class="huashuListItemDetailNoHide" v-html="item.allText"></div>
                            <div v-if="item.title">
                                <div :class="(item.showBtn&&item.showBtn=='shouqi')?'huashuListItemDetailShowmore':'huashuListItemDetail'"
                                    :style="{'-webkit-line-clamp':wenanShowLineCount==-1?'unset':wenanShowLineCount}"
                                    :ref="'show'+item.id" @click="itemClick(idx)" @dblclick="itemClick(idx,true)" v-html="item.allText"></div>
                                <!-- <div v-if="item.showBtn=='zhankai'&&!hoverPreviewCheck" class="actionBtn" @click.stop="textShowClick(idx)"> -->
                                <!-- <div v-else-if="item.showBtn=='shouqi'&&!hoverPreviewCheck" class="actionBtn"
                                    @click.stop="textShowClick(idx)">收起</div> -->
                                <div v-if="item.showBtn=='zhankai'&&!hoverPreviewCheck" class="actionBtn" @click.stop="textShowClick(idx)">
                                    展开</div>
                                <div v-else-if="item.showBtn=='shouqi'&&!hoverPreviewCheck" class="actionBtn"
                                    @click.stop="textShowClick(idx)">收起</div>
                            </div>
                            <div v-else>
                                <div class="huashuListItemDetail huashuListItemDetailNoTitle" :ref="'show'+item.id"
                                    :style="{'text-indent':(item.imglist&&item.imglist.length)||(item.filelist&&item.filelist.length)?'26px':0,'display':(item.showBtn&&item.showBtn=='shouqi')?'block':'-webkit-box','-webkit-line-clamp':wenanShowLineCount==-1?'unset':wenanShowLineCount}"
                                    @click="itemClick(idx)" @dblclick="itemClick(idx,true)">
                                    <img v-if="item.imglist&&item.imglist.length" class="imgTmp"
                                        src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png"
                                        @click.stop="go2ImageList(idx)">
                                    <img v-else-if="item.filelist&&item.filelist.length" class="imgTmp"
                                        src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png"
                                        @click.stop="go2ImageList(idx)">
                                    <div v-html="item.allText"></div></div>
                                <!-- <div v-if="item.showBtn=='zhankai'&&!hoverPreviewCheck" class="actionBtn" @click.stop="textShowClick(idx)">
                                    展开</div>
                                <div v-else-if="item.showBtn=='shouqi'&&!hoverPreviewCheck" class="actionBtn"
                                    @click.stop="textShowClick(idx)">收起</div> -->
                                    <div v-if="item.showBtn=='zhankai'&&!hoverPreviewCheck" class="actionBtn" @click.stop="textShowClick(idx)">
                                    展开</div>
                                <div v-else-if="item.showBtn=='shouqi'&&!hoverPreviewCheck" class="actionBtn"
                                    @click.stop="textShowClick(idx)">收起</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="tabIndex==1">
                        <div class="huashuListItem" :style="{'border':'none'}">
                            <div v-if="themeList.length&&themeList[themeSelIdx].title" class="huashuListItemTop">
                                <!-- <img class="huashuListItemTopL" src="https://imagessl.edujia.com/A-1ed71af7_20230804141027.png"> -->
                                <!-- <div class="huashuListItemTopM huashuListItemTopMBig">{{themeList[themeSelIdx].title}}</div> -->
                                <!--  <img v-if="item.imglist&&item.imglist.length" class="huashuListItemTopR" src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png" @click="go2ImageList(idx)">
                                    <img v-else-if="item.filelist&&item.filelist.length" class="huashuListItemTopR" src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png" @click="go2ImageList(idx)"> -->
                            </div>
                            <!-- <div v-for="(wenan,idx) in wenanList" @contextmenu.prevent="showWenanMenu($event,wenan,idx)"> -->
                            <div v-for="(wenan,idx) in wenanList" :key="'wenanListItem'+idx" class="huashuListItemDetailP">
                                <div :ref="wenan.libraryId" class="huashuListItemDetailNoHide">{{wenan.text}}</div>
                                <!-- <div v-if="item.title"> -->
                                <div :class="(wenan.showBtn&&wenan.showBtn=='shouqi')?'huashuListItemDetailShowmore':'huashuListItemDetail'"
                                    :style="{'-webkit-line-clamp':wenanShowLineCount==-1?'unset':wenanShowLineCount}"
                                    :ref="'show'+wenan.libraryId" @click="wenanItemClick(idx)" @dblclick="wenanItemClick(idx,true)">{{wenan.text}}</div>
                                <div v-if="wenan.showBtn=='zhankai'&&!hoverPreviewCheck" class="actionBtn" @click.stop="textShowClick(idx)">
                                    展开</div>
                                <div v-else-if="wenan.showBtn=='shouqi'&&!hoverPreviewCheck" class="actionBtn"
                                    @click.stop="textShowClick(idx)">收起</div>
                                <!-- </div>
                                    <div v-else>
                                        <div class="huashuListItemDetail huashuListItemDetailNoTitle" :ref="'show'+item.id" :style="{'text-indent':(item.imglist&&item.imglist.length)||(item.filelist&&item.filelist.length)?'23px':0,'display':(item.showBtn&&item.showBtn=='shouqi')?'block':'-webkit-box'}" @click="itemClick(idx)">
                                            <img v-if="item.imglist&&item.imglist.length" class="imgTmp" src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png" @click.stop="go2ImageList(idx)">
                                            <img v-else-if="item.filelist&&item.filelist.length" class="imgTmp" src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png" @click.stop="go2ImageList(idx)">
                                            {{item.allText}}
                                        </div>
                                        <div v-if="item.showBtn=='zhankai'" class="actionBtn" @click.stop="textShowClick(idx)">展开</div>
                                        <div v-else-if="item.showBtn=='shouqi'" class="actionBtn" @click.stop="textShowClick(idx)">收起</div>
                                    </div> -->
                            </div>
                        </div>
                        
                    </div>
                    <!-- <huashu-item-right-menu v-show="menuShow" ref="chat-item-right-menu" :menuY="menuPos[1]" :menuX="menuPos[0]" :menuData="menuData" @edit="editHuashu" @remove="removeHuashu" @hideMenu="hideMenu"></huashu-item-right-menu> -->
                </div>
            </multipane>
        </div>
        <right-menu v-show="menuShow" ref="chat-item-right-menu" :menuY="menuPos[1]" :menuX="menuPos[0]"
            :cellList="menuCellList" @cellClick="rightMenuCellClick" @hideMenu="hideMenu"></right-menu>
        <div  v-if="tabIndex==0" class="bottomBarP" ref="bottomBarP">
            <div class="bottomBar">
                <div class="bottomBarL">
                    <div class="addTypeBtn" @click="addHuashuType">
                        <img src="https://imagessl.edujia.com/A-1ed71af7_20230825105123.png" />
                        <div>添加分类</div>
                    </div>
                    <div class="addHuashuBtn" @click="addHuashu">
                        <img src="https://imagessl.edujia.com/A-1ed71af7_20230825105123.png" />
                        <div>添加话术</div>
                    </div>
                    <div class="importHuashuBtn" @click="importHuashu">
                        <img src="https://imagessl.lingtuo.cn/A-1ed71af7_20241028160310.png">
                        <div>导入话术</div>
                    </div>
                </div>
                <!-- <div class="psLbl">鼠标右键编辑/删除</div> -->
                <div class="faceBtn" @click="faceBtnClick"><div>&#128515</div><div class="faceBtnlbl">表情</div></div>
            </div>
        </div>
        <el-dialog title="选择分类" :visible.sync="showChooseHuashuTypeDialog">
            <div class="chooseHuashuTypeList">
                <div v-for="(item,idx) in typeList"
                    :class="chooseTypeSelIdx==idx?'typeListItemSel typeListItem':'typeListItem'"
                    :key="'huashuChooseType'+idx" @click="chooseHuashuTypeClick(idx)">
                    <div>{{item.labelName}}</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="chooseHuashuTypeCancel">取 消</el-button>
                <el-button type="primary" @click="chooseHuashuTypeConfirm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="sortDialogVisible" :show-close="true" width="480px"
          custom-class="sortTypeDialog" @close="closeSortDialog">
          <div slot="title" class="sortDialogHeader">
            <span class="sortDialogTitle">按住分类拖动排序</span>
            <div class="sortDialogSaveBtn" @click="saveSortOrder">保存</div>
          </div>
          <transition-group name="sort-flip" tag="div" class="sortTypeList">
            <div v-for="(item, idx) in sortTypeList" :key="item.labelId"
              class="sortTypeItem"
              :class="{
                'sortTypeItemDragging': dragIndex === idx,
                'sortTypeItemDragOver': dragOverIndex === idx && dragIndex !== idx
              }"
              draggable="true"
              @dragstart="onSortDragStart(idx)"
              @dragover.prevent="onSortDragOver(idx)"
              @drop="onSortDrop(idx)"
              @dragend="onSortDragEnd">
              <div>{{ item.labelName }}</div>
            </div>
          </transition-group>
        </el-dialog>
        <el-dialog title="行业/产品" :visible.sync="showProductDialog" width="420px" :append-to-body="true" @close="onProductDialogClose">
            <div class="xkProductList">
                <div v-if="!productList.length" class="xkProductEmpty">请到APP-销冠键盘，添加产品</div>
                <div v-for="(item,idx) in productList" :key="'product'+idx"
                    :class="xkSelProductIdx==idx?'xkProductItem xkProductItemSel':'xkProductItem'"
                    @click="productItemClick(idx)">
                    <div>{{item.name}}</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="选择团队" :visible.sync="showHuashuSelectDialog" width="520px" :append-to-body="true" @close="onHuashuSelectDialogClose">
            <div class="xkTeamList">
                <div v-if="!huashuTeamList.length" class="xkProductEmpty">暂无数据</div>
                <div v-for="(item,idx) in huashuTeamList" :key="'xkTeam'+idx"
                    :class="xkSelTeamIdx==idx?'teamListItemSel teamListItem':'teamListItem'"
                    @click="xkTeamItemClick(idx)">
                    <img v-if="item.roleId==1" src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png" />
                    <img v-else-if="item.roleId==2" src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png" />
                    <div>{{item.showName}}</div>
                </div>
            </div>
        </el-dialog>
        <face-panel v-if="facePanelShow" @facePanelClose="facePanelShow=false" @emojiClick="emojiClick"></face-panel>
        <!-- <el-dialog title="文案显示" custom-class="wenanLineCountDialog" :visible.sync="huashuLineCountDialogShow"
            @close='()=>{this.$store.commit("modifyHuashuLineCountDialogShow",false)}'>
            <div class="chooseHuashuTypeList">
                <el-radio-group v-model="tmpWenanShowLineCount" :style="{'display':'grid'}">
                    <el-radio :label="1" :style="{'margin-bottom':'10px'}">最多显示1行内容</el-radio>
                    <el-radio :label="3" :style="{'margin-bottom':'10px'}">最多显示3行内容</el-radio>
                    <el-radio :label="-1" :style="{'margin-bottom':'10px'}">全部显示</el-radio>
                </el-radio-group>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="wenanLineCountCancel">取 消</el-button>
                <el-button type="primary" @click="wenanLineCountConfirm">确 定</el-button>
            </div>
        </el-dialog> -->
    </div>


</template>

<script>
    import axios from 'axios'
    import dbService from '@/service/dbService'
    import Vue from 'vue'
    import Fuse from 'fuse.js'
    import {
        Dialog,
        Button,
        Loading,
        Radio,
        RadioGroup,
        Switch,
        Checkbox,
        Message
    } from 'element-ui';
    Vue.use(Dialog)
    Vue.use(Button)
    Vue.use(Loading)
    Vue.use(RadioGroup)
    Vue.use(Radio)
    Vue.use(Switch)
    Vue.use(Checkbox)

    import LoginDialog from "./LoginDialog";
    import rightMenu from '@/components/RightMenu'
    import facePanel from '@/components/FacePanel'
    import {
        Multipane,
        MultipaneResizer
    } from 'vue-multipane';
    // var mammoth = require("mammoth");

    export default {
        name: "Home",
        data() {
            return {
                pageWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                pageHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                typeSelIdx: 0,
                teamSelIdx: 0,
                typeList: [],
                typeListLoadend: false,
                huashuList: [],
                showHuashuList: [],
                huashuListLoadend: false,
                huashuTeamList: [],
                typePageSize: 500,
                typePage: 1,
                huashuPageSize: 500,
                huashuPage: 1,
                speechId: 0, //团队id
                labelId: 0, //分类id
                huashuDetailId: 0, //话术文本id
                huashuTopBarShow: true,
                defaultThemeList: [], //默认文案包列表
                themeList: [], //文案包列表
                themeSelIdx: 0, //当前选中文案包索引
                themeId: 0, //当前选中文案包id
                themePage: 1,
                themePageSize: 500,
                themeCategoryList: [], //当前选中文案包分类列表
                themeCategorySelIdx: 0, //当前选中文案包分类索引
                themeCategoryPage: 1,
                themeCategoryPageSize: 20,
                themeCategoryLoading: false,
                themeCategoryLoadend: false,
                wenanLabelId: 0, //文案包分类id
                wenanPage: 1,
                wenanPageSize: 500,
                wenanloading: false,
                wenanList: [],
                wenanListLoadend: false,
                wenanId: 0, //文案id
                teamListShow: false,
                xiaoguanShow: false,
                xiaoguanQuestion: "",
                xkCategorySelIdx: -1,
                xkCategoryLoading: false,
                xkSegmentTab: 0,
                showProductDialog: false,
                xkSelProductIdx: -1,
                xkSelProduct: "",
                productList: [],
                showProductAddInput: false,
                newProductName: "",
                showHuashuSelectDialog: false,
                xkSelTeamIdx: -1,
                xiaoguanCategoryList: [
                    { label: "智能回复", key: "高情商" },
                    { label: "议价问题", key: "议价" },
                    { label: "建立信任", key: "信任" },
                    { label: "挖掘需求", key: "需求" },
                    { label: "产品异议", key: "异议" },
                    { label: "塑造价值", key: "价值" },
                    { label: "签单推进", key: "签单" },
                    { label: "遭遇拒绝", key: "拒绝" },
                    { label: "逼单成交", key: "逼单" },
                    { label: "销冠回复", key: "销冠" },
                    { label: "产品介绍", key: "产品介绍" },
                    { label: "售后维护", key: "售后维护" },
                    { label: "转介绍", key: "转介绍" },
                    { label: "闲聊", key: "闲聊" },
                    { label: "客情维系", key: "客情维系" },
                    { label: "邀约", key: "邀约" },
                    { label: "复购", key: "复购" },
                    { label: "签单祝贺", key: "签单祝贺" },
                    { label: "客户挽留", key: "客户挽留" },
                ],
                xkCategoryList2: [
                    { label: "自我介绍", key: "自我介绍" },
                    { label: "需求探寻", key: "需求探寻" },
                    { label: "消除顾虑", key: "消除顾虑" },
                    { label: "互动提问", key: "互动提问" },
                    { label: "传达价值", key: "传达价值" },
                    { label: "挖掘兴趣", key: "挖掘兴趣" },
                    { label: "情感链接", key: "情感链接" },
                    { label: "分享趋势", key: "分享趋势" },
                    { label: "引导深入", key: "引导深入" },
                    { label: "闲聊", key: "闲聊" },
                    { label: "客情维系", key: "客情维系" },
                    { label: "邀约", key: "邀约" },
                    { label: "复购", key: "复购" },
                    { label: "签单祝贺", key: "签单祝贺" },
                    { label: "客户挽留", key: "客户挽留" },
                ],
                loading: false,
                hushuTypeLoading: false,
                audioList: [],
                eleList: [],
                faceIcon: "",
                // loginDailogShow:false,
                menuPos: [],
                menuShow: false,
                menuData: {},
                tabIndex: 0,
                keywords: "",
                searchPage: 1,
                searchPageSize: 50,
                searchLoadend: false,
                searchLoading: false,
                isSeaching: false,
                typeListWidth: 144,
                menuCellList: [],
                countTopHuashu: 0,
                showChooseHuashuTypeDialog: false,
                chooseTypeSelIdx: 0,
                huashuItemHoverTimer:null,
                huashuItemHoverIdx:-1,
                isAISearch:false,
                aiSearchHeight:48,
                aiSearchType:1,//ai搜索类型：1.关键词搜搜 2.AI搜索
                facePanelShow:false,
                isHuashuItemHovering:false,//判断是否是悬停查看话术详情状态
                itemClickTimer:null,
                searchType:"",//类型：1增量同步，2七牛云同步，3服务端搜索，4更新同步参数无增量数据
                localHuashuListData:[],
                huashuValList:[],
                currentHuashuTeamInfo:null,
                sortDialogVisible: false,
                sortTypeList: [],
                dragIndex: -1,
                dragOverIndex: -1
            }
        },
        computed: {
            xkCurrentCategoryList() {
                return this.xkSegmentTab === 0 ? this.xiaoguanCategoryList : this.xkCategoryList2;
            },
            showAiSwitch(){
                // return this.isSeaching&&(this.huashuTeamList[this.teamSelIdx].roleId==2||this.huashuTeamList[this.teamSelIdx].isOpenAiRec)
                return this.isSeaching&&this.huashuTeamList[this.teamSelIdx].roleId==2
            },
            contentHeight() {
                let height = this.pageHeight - 125 - 40;
                if(this.isSeaching&&this.showAiSwitch){
                    height-=this.aiSearchHeight
                }
                if (this.tabIndex == 1) {
                    height += 32 + 40;
                }
                return height;
            },
            loginDailogShow() {
                return this.$store.state.loginDailogShow;
            },
            wenanShowLineCount(){
                console.log("this.$store.state.settingInfo.wenanShowLineCount:",this.$store.state.settingInfo.wenanShowLineCount);
                return this.$store.state.settingInfo.wenanShowLineCount?this.$store.state.settingInfo.wenanShowLineCount:3
            },
            titleColor(){
                console.log("this.$store.state.settingInfo.color:",this.$store.state.settingInfo.color);
                return this.$store.state.settingInfo.color?this.$store.state.settingInfo.color:'#4A90E2';
            },
            hoverPreviewCheck(){
                return this.$store.state.settingInfo&&this.$store.state.settingInfo.hoverPreviewCheck
            },
        },
        watch: {
            typeListWidth(val){
                console.log("typeListWidth change:",val)
            },
            isAISearch(){
                if(this.isSeaching){
                    this.searchPage = 1;
                    this.huashuList = [];
                    this.searchLoadend = false;
                    this.searchHuashu();
                }
            },
            aiSearchType(){
                if(this.isSeaching){
                    this.searchPage = 1;
                    this.huashuList = [];
                    this.searchLoadend = false;
                    this.searchHuashu();
                }
            },
            wenanShowLineCount(val) {
                this.updateCellStyle();
            },
            keywords(val) {
                if (!val) {
                    this.isSeaching = false;
                }
            },
            huashuList(val) {
                console.log("watch huashuList update:", val);
                if (this.huashuTopBarShow) {
                    this.showHuashuList = this.huashuList;
                } else {
                    this.showHuashuList = this.huashuList.filter((huashu) => {
                        return !huashu.isTop
                    });
                }
                this.countTopHuashu = this.huashuList.filter((val) => {
                    return val.isTop
                }).length;
            },
        },
        components: {
            LoginDialog,
            rightMenu,
            Multipane,
            MultipaneResizer,
            facePanel
        },
        methods: {
            replaceHuashuBianliang(text){
                this.huashuValList.forEach((val)=>{
                    text=this.replaceAll(text, "{$*"+val.id+"*$}" , val.value);
                })
                const regex = /\{\$\*\d+\*\$\}/g;
                text = text.replace(regex, "[变量]");
                return text;
            },
            getSyncParams(speechId){
                let syncParams=null;
                let resultIdx = -1;
                let syncParamsList = [];
                if(localStorage.getItem("syncParamsList")){
                    syncParamsList = JSON.parse(localStorage.getItem("syncParamsList"));
                    resultIdx = syncParamsList.findIndex((val)=>{return val.speechId == speechId})
                    if(resultIdx>=0){
                        syncParams = syncParamsList[resultIdx].syncParams;
                    }
                }
                return syncParams;
            },
            updateSyncParams(syncParams,speechId){
                return new Promise((resolve,reject)=>{
                    let resultIdx = -1;
                    let syncParamsList = [];
                    if(localStorage.getItem("syncParamsList")){
                        syncParamsList = JSON.parse(localStorage.getItem("syncParamsList"));
                        resultIdx = syncParamsList.findIndex((val)=>{return val.speechId == speechId})
                        if(resultIdx>=0){
                            syncParams = syncParamsList[resultIdx].syncParams;
                        }
                    }
                    if(resultIdx>=0){
                        syncParamsList[resultIdx].syncParams =syncParams 
                    }else{
                        syncParamsList.push({
                            syncParams:syncParams,
                            speechId:speechId
                        })
                    }
                    localStorage.setItem("syncParamsList",JSON.stringify(syncParamsList));
                    resolve();
                })
            },
            async huashuCheckIncrement(){
                return new Promise(async (resolve,reject)=>{
                    let syncParams=this.getSyncParams(this.speechId);
                    let params = {
                        speechId: this.speechId,
                    }
                    if(syncParams){
                        params.syncParams = syncParams;
                    }
                    console.log("huashuCheckIncrement params=", params);
                    let resp = await this.$http.huashuCheckIncrement(params)
                    if (resp.code == 200) {
                        if(resp.data.object.syncParams){
                           await this.updateSyncParams(resp.data.object.syncParams,this.speechId)
                        }
                        this.searchType = resp.data.object.type;
                        //有增量更新
                        if(this.searchType!=4){
                            if(this.searchType==2){
                                //七牛云同步
                                axios.get(resp.data.object.url).then(async response => {
                                    console.log("response:",response);
                                    if(response.data&&response.data.length){
                                        this.localHuashuListData.push(...response.data);
                                        await dbService.addData('huashuList',response.data,new Date().getTime(),this.speechId)
                                    }
                                    await this.huashuCheckIncrement(resp.data.object.syncParams);
                                    resolve();
                                })
                            }else if(this.searchType==1){
                                //增量添加
                                await this.huashuCheckIncrementAdd(resp.data.object.syncParams);

                                //增量删除
                                await this.huashuCheckIncrementDel(resp.data.object.syncParams);
                                resolve();
                            }
                        }else{
                            resolve();
                        }
                    }
                })
            },
            //增量添加
            huashuCheckIncrementAdd(syncParams){
                return new Promise(async (resolve,reject)=>{
                    let zenParam={
                        speechId:this.speechId,
                    }
                    if(syncParams){
                        zenParam.syncParams = syncParams;
                    }
                    let zenResp = await this.$http.huashuCheckIncrementAdd(zenParam)
                    if(zenResp.code == 200){
                        if(zenResp.data.syncParams){
                            await this.updateSyncParams(zenResp.data.syncParams,this.speechId)
                        }
                        if(zenResp.data.array.length){
                            await dbService.addData('huashuList',zenResp.data.array,this.speechId)
                            this.localHuashuListData.push(...zenResp.data.array);
                            if(zenResp.data.isNextData){
                                await this.huashuCheckIncrementAdd(zenResp.data.syncParams)
                            }
                        }else{
                            console.log("增量增加拉取结束...");
                        }
                    }
                    resolve();
                })
            },
            //增量删除
            huashuCheckIncrementDel(syncParams){
                return new Promise(async (resolve,reject)=>{
                    let delParam={
                        speechId:this.speechId,
                    }
                    if(syncParams){
                        delParam.syncParams = syncParams;
                    }
                    let delResp = await this.$http.huashuCheckIncrementDel(delParam)
                    if(delResp.code == 200){
                        if(delResp.data.syncParams){
                           await this.updateSyncParams(delResp.data.syncParams,this.speechId)
                        }
                        if(delResp.data.array.length){
                            // this.localHuashuListData.push(...response.data);
                            this.localHuashuListData=this.localHuashuListData.filter((item)=>{
                                return !delResp.data.array.some((removeitem)=>{
                                    return removeitem.id == item.id;
                                })
                            })
                            await dbService.delData('huashuList',delResp.data.array)
                            if(delResp.data.isNextData){
                                await this.huashuCheckIncrementDel(delResp.data.syncParams)
                            }
                        }else{
                            console.log("增量删除拉取结束...");
                        }
                    }
                    resolve();
                })
            },
            getHuashuItemBgColor(item,idx){
                let color = '#fff'
                if(item.isTop&&!this.isSeaching){
                    color = '#eee'
                }

                if(this.huashuItemHoverIdx==idx){
                    if(color=='#fff'){
                        color = '#eee'
                    }else{
                        color = '#fff'
                    }
                }

                return color;
            },
            emojiClick(emoji){
                navigator.clipboard.writeText(emoji.emoji).then(() => {
                    this.$message({
                        message: '文本已复制',
                        type: 'success'
                    });
                    const {ipcRenderer} = window.require('electron');
                    ipcRenderer.send('type-text', emoji.emoji);
                }, function () {
                    console.log('文件复制失败！');
                });
            },
            faceBtnClick(){
                this.facePanelShow=!this.facePanelShow;
            },
            openTopHuashu() {
                this.huashuTopBarShow = !this.huashuTopBarShow;
                if (this.huashuTopBarShow) {
                    this.showHuashuList = this.huashuList;
                    localStorage.removeItem("huashuTopBarHide");
                } else {
                    this.showHuashuList = this.huashuList.filter((huashu) => {
                        return !huashu.isTop
                    });
                    localStorage.setItem("huashuTopBarHide", 1);
                }
                this.updateCellStyle();
            },
            chooseHuashuTypeCancel() {
                this.showChooseHuashuTypeDialog = false;
            },
            async chooseHuashuTypeConfirm() {
                const loading = Loading.service({
                    lock: true,
                    text: '加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let params = {
                    speechId: this.speechId,
                    labelId: this.typeList[this.typeSelIdx].labelId,
                    id: this.menuData.id,
                    targetLabelId: this.typeList[this.chooseTypeSelIdx].labelId,
                }
                console.log("huashuTypeSave params=", params);
                let resp = await this.$http.moveHuashuType(params)
                if (resp.code == 200) {
                    let huashuIdx = this.huashuList.findIndex((huashu) => {
                        return huashu.id == this.menuData.id
                    });
                    this.huashuList.splice(huashuIdx, 1);

                } else {
                    this.$message({
                        message: resp.message,
                        type: 'warning'
                    });
                }
                this.showChooseHuashuTypeDialog = false;
                loading.close();
            },
            //选择话术分类
            chooseHuashuTypeClick(idx) {
                this.chooseTypeSelIdx = idx;
            },
            convertFileData(text) {
                const regex = /【([^【】]+)】(?:\n\n((?:■[^【]+(?:\n[^【■]+)*)*))/g;
                let matches;
                const result = [];

                while ((matches = regex.exec(text)) !== null) {
                    const category = matches[1].trim();
                    const categoryText = matches[2].trim();

                    // 解析分类中的标题和内容
                    const categoryRegex = /■([^【\n]+)\n([^■]*)/g;
                    let categoryMatches;
                    const categoryData = [];

                    while ((categoryMatches = categoryRegex.exec(categoryText)) !== null) {
                        const title = categoryMatches[1].trim();
                        const content = categoryMatches[2].trim().replace(/\n+/g, '\n');
                        categoryData.push({
                            title,
                            content
                        });
                    }

                    // 添加分类到结果数组
                    result.push({
                        type: category,
                        sub: categoryData
                    });
                }
                console.log('convertFileData result:', result)
                return result;
            },
            paneresizestop(e) {
                localStorage.setItem('typeListWidth', e.clientWidth)
                this.typeListWidth = e.clientWidth;
            },
            async cancelSearch(){
                this.isSeaching = false;
                this.huashuPage = 1;
                this.huashuList = [];
                this.keywords = '';
                this.huashuListLoadend = false;
                this.fetchHuashuList();
            },
            async searchBtnClick() {
                this.isSeaching = true;
                this.searchPage = 1;
                this.huashuList = [];
                this.searchLoadend = false;
                this.searchHuashu();
            },
            async localSearchHuashu(){
                return new Promise(async (resolve,reject)=>{
                    console.log("localSearchHuashu...");
                    // let localHuashuList = await dbService.search(this.keywords,'huashuList')
                    // this.localHuashuListData = await dbService.getAllData("huashuList")
                    let localHuashuListData=this.localHuashuListData;
                    console.log("localHuashuList:",localHuashuListData);
                    let options= {
                        keys: ['title', 'speechText', 'allText'], // 多个搜索键
                        threshold: 0.6, // 阈值控制匹配的敏感度
                        shouldSort: true, // 是否对结果进行排序
                        location: 0, // 匹配的位置，0 表示开头匹配
                        distance: 100, // 搜索的最大距离
                        minMatchCharLength: 2, // 最小匹配字符长度
                    }
                    const fuse = new Fuse(localHuashuListData, options);
                    let localHuashuList = fuse.search(this.keywords).map((val)=>{
                        return val.item
                    });
                    console.log("localSearchHuashu result:",localHuashuList);
                    if(!localHuashuList){
                        return;
                    }
                    localHuashuList = localHuashuList.map((val) => {
                        val.eleList = this.generateEleList(val.speechText);
                        val.imglist = val.eleList.filter((eleListItem) => {
                            eleListItem.val = eleListItem.val.replace("http://", "https://")
                            return eleListItem.type == 'img' || eleListItem.type == 'video'
                        })
                        val.filelist = val.eleList.filter((eleListItem) => {
                            eleListItem.val = eleListItem.val.replace("http://", "https://")
                            return eleListItem.type == 'file' || eleListItem.type == 'audio'
                        })
                        val.allText = this.getEleListAllText(val.eleList);
                        return val;
                    })
                    this.huashuList.splice(this.huashuList.length, 0, ...localHuashuList);
                    if (this.huashuTopBarShow) {
                        this.showHuashuList = this.huashuList;
                    } else {
                        this.showHuashuList = this.huashuList.filter((huashu) => {
                            return !huashu.isTop
                        });
                    }
                })
            },
            async searchHuashu() {
                if(false){
                    //检查增量更新搜索
                    await this.huashuCheckIncrement();
                    if(this.searchType!=3&&!(this.isAISearch&&this.aiSearchType==2)){
                        await this.localSearchHuashu();
                        return;
                    }
                }

                this.searchLoading = true;
                let params = {
                    page: this.searchPage,
                    pageSize: this.searchPageSize,
                    speechId: this.speechId,
                    keyword: this.keywords,
                    isAIEnable: this.isAISearch&&this.aiSearchType==2 ? 1 : 0
                }
                console.log("huashuSearch params:", params);
                let resp = await this.$http.huashuSearch(params);
                console.log("huashuSearch resp:", resp);
                if (resp.code == 200) {
                    if (resp.data.array.length) {
                        resp.data.array = resp.data.array.map((val) => {
                            val.eleList = this.generateEleList(val.speechText);
                            val.imglist = val.eleList.filter((eleListItem) => {
                                eleListItem.val = eleListItem.val.replace("http://", "https://")
                                return eleListItem.type == 'img' || eleListItem.type == 'video'
                            })
                            val.filelist = val.eleList.filter((eleListItem) => {
                                eleListItem.val = eleListItem.val.replace("http://", "https://")
                                return eleListItem.type == 'file' || eleListItem.type == 'audio'
                            })
                            val.allText = this.getEleListAllText(val.eleList);
                            return val;
                        })
                        this.huashuList.splice(this.huashuList.length, 0, ...resp.data.array);
                        if (this.huashuTopBarShow) {
                            this.showHuashuList = this.huashuList;
                        } else {
                            this.showHuashuList = this.huashuList.filter((huashu) => {
                                return !huashu.isTop
                            });
                        }
                    }
                    if (resp.data.array.length < this.searchPageSize) {
                        this.searchLoadend = true;
                    } else {
                        this.searchPage++;
                    }
                }
                this.searchLoading = false;
            },
            rightMenuCellClick(idx) {
                if (this.huashuTeamList[this.teamSelIdx] && this.huashuTeamList[this.teamSelIdx].roleId == 0) {
                    this.$message({
                        message: '无权限',
                        type: 'warning'
                    });
                    return;
                }

                if (this.menuCellList[idx].action == 'removeHuashu') {
                    //删除话术
                    this.removeHuashu()
                }
                else if (this.menuCellList[idx].action == 'insertHuashu') {
                    //新增话术
                    this.addHuashu();
                }
                else if (this.menuCellList[idx].action == 'editHuashu') {
                    //编辑话术
                    this.editHuashu();
                } else if (this.menuCellList[idx].action == 'setHuashuTop') {
                    //固定置顶话术
                    this.setHuashuTop();
                } else if (this.menuCellList[idx].action == 'setHuashuNoTop') {
                    //取消置顶话术
                    this.setHuashuNoTop();
                } else if (this.menuCellList[idx].action == 'moveHuashu2First') {
                    //刷到顶部
                    this.moveHuashu2First();
                } else if (this.menuCellList[idx].action == 'moveHuashuType') {
                    //移动话术类型
                    this.moveHuashuType();
                } else if (this.menuCellList[idx].action == 'editHuashuType') {
                    //编辑话术类型
                    this.editHuashuType();
                } else if (this.menuCellList[idx].action == 'refreshHuashuType') {
                    //刷新话术类型
                    this.refreshHuashuType();
                } else if (this.menuCellList[idx].action == 'autoSend') {
                    //逐条发送
                    this.autoSend();
                } else if (this.menuCellList[idx].action == 'sortHuashuType') {
                    this.openSortDialog();
                }
            },
            tabClick(idx) {
                this.isSeaching = false;
                this.keywords = "";
                this.tabIndex = idx;
                this.xiaoguanShow = false;
                this.fetchData();
            },
            importHuashu() {
                this.$router.push({
                    path: '/huashuImport',
                    query: {
                        speechId: this.speechId,
                        labelId: this.labelId,
                        teamName: this.huashuTeamList[this.teamSelIdx].showName
                    }
                })
            },
            addHuashuType() {
                this.$prompt('', '添加分类', {
                    confirmButtonText: '保存',
                    cancelButtonText: '取消',
                    inputPattern: /^.+$/,
                    inputErrorMessage: '分类名称不能为空'
                }).then(async ({
                    value
                }) => {
                    let params = {
                        speechId: this.speechId,
                        labelName: value
                    }
                    console.log("huashuTypeSave params=", params);
                    let resp = await this.$http.huashuTypeSave(params)
                    if (resp.code == 200) {
                        console.log("huashuTypeSave resp:", resp);
                        this.typeList.splice(this.typeList.length, 0, resp.data.object)
                        this.huashuClick(0);
                    } else {
                        this.$message({
                            message: resp.message,
                            type: 'warning'
                        });
                    }
                }).catch(() => {});
            },
            addHuashu() {
                if(!this.labelId){
                    this.$message({
                        message: '请先创建分类',
                        type: 'warning'
                    });
                    return;
                }

                let team = this.huashuTeamList[this.teamSelIdx];
                if (team.roleId == 0) {
                    this.$message({
                        message: "无权限操作此话术",
                        type: 'warning'
                    });
                    return;
                }

                if (localStorage.getItem("editHuashuData")) {
                    localStorage.removeItem("editHuashuData")
                }
                // this.$router.push({
                //     path: '/huashuEdit',
                //     query: {
                //         speechId: this.speechId,
                //         labelId: this.labelId
                //     }
                // })
                if(window.require){
                    const {ipcRenderer} = window.require('electron');
                    ipcRenderer.send('openHuashuEdit', JSON.stringify({
                        speechId: this.speechId,
                        labelId: this.labelId,
                        
                    }));
                }
            },
            async removeHuashu() {
                if (this.huashuTeamList[this.teamSelIdx].roleId != 0) {
                    this.$confirm('确定删除？', '', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        let params = {
                            speechId: this.speechId,
                            labelId: this.menuData.labelId,
                            id: this.menuData.id,
                        }
                        console.log("huashuRemove params=", params);
                        let resp = await this.$http.huashuRemove(params)
                        if (resp.code == 200) {
                            console.log("huashuRemove resp:", resp);
                            this.huashuList.splice(this.menuData.idx, 1);
                            let tempList = this.huashuList.map((val, idx) => {
                                val.idx = idx;
                                return val;
                            })
                            this.huashuList = tempList;
                        } else {
                            this.$message({
                                message: resp.message,
                                type: 'warning'
                            });
                        }
                    }).catch(() => {

                    });
                } else {
                    this.$message({
                        message: "无权限操作此话术",
                        type: 'warning'
                    });
                }
            },
            editHuashu() {
                if (this.huashuTeamList[this.teamSelIdx].roleId != 0) {
                    if(window.require){
                        const {ipcRenderer} = window.require('electron');
                        ipcRenderer.send('openHuashuEdit', JSON.stringify({
                            speechId: this.speechId,
                            labelId: this.menuData.labelId,
                            editHuashuData: this.menuData
                        }));
                    }else{
                        let editData = Object.assign({}, this.menuData, {speechId: this.speechId});
                        localStorage.setItem("editHuashuData", JSON.stringify(editData))
                        this.$router.push({
                            path: '/huashuEdit',
                            query: {
                                speechId: this.speechId,
                                isWeb:true,
                                // labelId: this.labelId,
                                // editHuashuData: this.menuData
                            }
                        })
                    }
                } else {
                    this.$message({
                        message: "无权限操作此话术",
                        type: 'warning'
                    });
                }
            },
            editHuashuType() {
                console.log("this.menuData:", this.menuData);
                this.$prompt('', '修改分类', {
                    confirmButtonText: '保存',
                    cancelButtonText: '取消',
                    inputPattern: /^.+$/,
                    inputErrorMessage: '分类名称不能为空'
                }).then(async ({
                    value
                }) => {
                    let rightIdx = this.typeList.findIndex(val => val.labelId == this.menuData.labelId)
                    let type = this.typeList[rightIdx];
                    let params = {
                        speechId: this.speechId,
                        labelName: value,
                        labelId: type.labelId,
                    }
                    console.log("huashuTypeSave params=", params);
                    let resp = await this.$http.huashuTypeSave(params)
                    if (resp.code == 200) {
                        console.log("huashuTypeSave resp:", resp);
                        type.labelName = value;
                        this.typeList.splice(rightIdx, 1, type)
                    } else {
                        this.$message({
                            message: resp.message,
                            type: 'warning'
                        });
                    }
                }).catch(() => {});
            },
            //话术刷到顶部
            async moveHuashu2First() {
                let params = {
                    speechId: this.speechId,
                    labelId: this.typeList[this.typeSelIdx].labelId,
                    id: this.menuData.id,
                }
                console.log("huashuRefreshTop params=", params);
                let resp = await this.$http.huashuRefreshTop(params);
                if (resp.code == 200) {
                    let huashuIdx = this.huashuList.findIndex((huashu) => {
                        return huashu.id == this.menuData.id
                    });
                    let huashuItem = this.huashuList[huashuIdx];
                    this.huashuList.splice(huashuIdx, 1);
                    if (!this.menuData.isTop) {
                        let huashuNoIsTopIdx = this.huashuList.findIndex((huashu) => {
                            return !huashu.isTop
                        });
                        this.huashuList.splice(huashuNoIsTopIdx, 0, huashuItem)
                    } else {
                        this.huashuList.splice(0, 0, huashuItem)
                    }
                }
            },
            //话术自动发送
            autoSend(){
                if(window.require){
                    const {ipcRenderer} = window.require('electron');
                    ipcRenderer.send('openAutoSend', JSON.stringify({
                        speechId: this.speechId,
                        labelId: this.menuData.labelId,
                        editHuashuData: this.menuData
                    }));
                }
            },
            //话术更新置顶
            setHuashuTop() {
                this.updateHuashuIsTop(1);
            },
            //话术取消置顶
            setHuashuNoTop() {
                this.updateHuashuIsTop(0);
            },
            //更新话术置顶状态
            async updateHuashuIsTop(isTop) {
                let params = {
                    speechId: this.speechId,
                    labelId: this.typeList[this.typeSelIdx].labelId,
                    id: this.menuData.id,
                    isTop: isTop
                }
                console.log("updateHuashuIsTop params=", params);
                let resp = await this.$http.updateHuashuIsTop(params);
                if (resp.code == 200) {
                    let huashuIdx = this.huashuList.findIndex((huashu) => {
                        return huashu.id == this.menuData.id
                    });
                    let huashuItem = this.huashuList[huashuIdx];
                    huashuItem.isTop = isTop;
                    this.huashuList.splice(huashuIdx, 1);
                    if (isTop) {
                        this.huashuList.splice(0, 0, huashuItem)
                    } else {
                        let huashuNoIsTopIdx = this.huashuList.findIndex((huashu) => {
                            return !huashu.isTop
                        });
                        this.huashuList.splice(huashuNoIsTopIdx, 0, huashuItem)
                    }
                }
            },
            //移动话术类型
            moveHuashuType() {
                this.showChooseHuashuTypeDialog = true;
            },
            //刷新话术类型
            async refreshHuashuType() {
                let params = {
                    speechId: this.speechId,
                    labelId: this.menuData.labelId,
                }
                console.log("huashuTypeRefreshTop params=", params);
                let resp = await this.$http.huashuTypeRefreshTop(params);
                if (resp.code == 200) {
                    let huashuTypeIdx = this.typeList.findIndex((huashuType) => {
                        return huashuType.labelId == this.menuData.labelId
                    });
                    let huashuTypeItem = this.typeList[huashuTypeIdx];
                    this.typeList.splice(huashuTypeIdx, 1);
                    this.typeList.splice(0, 0, huashuTypeItem)
                }
            },
            huashuItemMouseIn(e, item,idx){
                console.log("huashuItemMouseIn...");  
                this.huashuItemHoverIdx=idx;

                if(!this.hoverPreviewCheck){
                    return;
                }

                if(this.huashuItemHoverTimer){
                    return;
                }

                this.hoverShowing=true;
                let hoverPos = {
                    x:e.pageX,
                    y:e.pageY,
                };
                if(this.isHuashuItemHovering){
                    if(window.require){
                        const {ipcRenderer} = window.require('electron');
                        ipcRenderer.send('huashuItemHover', JSON.stringify({pos:hoverPos,text:item.allText}));
                    }
                    // return;
                }else{
                    // clearTimeout(this.huashuItemHoverTimer)
                    // this.huashuItemHoverTimer=null
                    this.huashuItemHoverTimer=setTimeout(()=>{   
                        this.isHuashuItemHovering=true;
                        if(window.require){
                            const {ipcRenderer} = window.require('electron');
                            ipcRenderer.send('huashuItemHover', JSON.stringify({pos:hoverPos,text:item.allText}));
                        }
                    },1000)
                }
            },
            huashuItemHover(e, item,idx){   
                
            },
            huashuItemMouseleave(){
                this.huashuItemHoverIdx=-1;          
                if(!this.hoverPreviewCheck){
                    return;
                }
                if(this.huashuItemHoverTimer){
                    clearTimeout(this.huashuItemHoverTimer)
                    this.huashuItemHoverTimer=null
                }
                if(window.require){
                    const {ipcRenderer} = window.require('electron');
                    ipcRenderer.send('huashuItemMouseleave');
                }
            },
            huashuListMouseleave(){
                this.huashuItemHoverIdx=-1; 
                if(!this.hoverPreviewCheck){
                    return;
                }
                if(this.huashuItemHoverTimer){
                    clearTimeout(this.huashuItemHoverTimer)
                    this.huashuItemHoverTimer=null
                }
                setTimeout(()=>{
                    this.isHuashuItemHovering=false
                    if(window.require){
                        const {ipcRenderer} = window.require('electron');
                        ipcRenderer.send('huashuItemMouseleave');
                    };
                },100)
            },
            hideMenu() {
                this.menuShow = false;
            },
            showMenu(e, item, idx) {
                console.log("showMenu e:", e);
                console.log("showMenu item:", item);
                // this.menuPos=[e.x,e.y-this.$refs.huashuList.scrollTop];
                this.menuPos = [e.x, e.y];
                this.menuData = item;
                this.menuData.idx = idx;
                if(!this.isSeaching){
                    this.menuCellList = [
                        {
                            label: '逐条发送',
                            action: 'autoSend'
                        },    
                        {
                            label: '编辑',
                            action: 'editHuashu'
                        },
                        {
                            label: '新增',
                            action: 'insertHuashu'
                        },
                        {
                            label: '刷到顶部',
                            action: 'moveHuashu2First'
                        },
                        {
                            label: '移动',
                            action: 'moveHuashuType'
                        },
                        {
                            label: '删除',
                            action: 'removeHuashu'
                        }
                    ]
                    if (!this.menuData.isTop) {
                        this.menuCellList.splice(2, 0, {
                            label: '固定置顶',
                            action: 'setHuashuTop'
                        })
                    } else {
                        this.menuCellList.splice(2, 0, {
                            label: '取消置顶',
                            action: 'setHuashuNoTop'
                        })
                    }
                }else{
                    this.menuCellList = [
                        {
                            label: '编辑',
                            action: 'editHuashu'
                        },
                        {
                            label: '删除',
                            action: 'removeHuashu'
                        }
                    ]
                    if (!this.menuData.isTop) {
                        this.menuCellList.splice(2, 0, {
                            label: '固定置顶',
                            action: 'setHuashuTop'
                        })
                    } else {
                        this.menuCellList.splice(2, 0, {
                            label: '取消置顶',
                            action: 'setHuashuNoTop'
                        })
                    }
                }
                this.menuShow = true;
            },
            showTypeMenu(e, item, idx) {
                console.log("showTypeMenu e:", e);
                console.log("showTypeMenu wenan:", item);
                this.menuPos = [e.x, e.y];
                this.menuData = item;
                this.menuData.idx = idx;
                this.menuCellList = [{
                        label: '修改',
                        action: 'editHuashuType'
                    },
                    {
                        label: '刷新',
                        action: 'refreshHuashuType'
                    },
                    {
                        label: '排序',
                        action: 'sortHuashuType'
                    }
                ]
                this.menuShow = true;
            },
            loginDailogClick() {
                this.$store.commit("modifyLoginDailogShow", !this.$store.state.loginDailogShow)
            },
            textShowClick(idx) {
                //关闭悬浮窗
                this.huashuItemMouseleave();

                if (this.tabIndex == 0) {
                    this.showHuashuList[idx].showBtn = this.showHuashuList[idx].showBtn == 'zhankai' ? 'shouqi' :
                        'zhankai'
                } else if (this.tabIndex == 1) {
                    this.wenanList[idx].showBtn = this.wenanList[idx].showBtn == 'zhankai' ? 'shouqi' : 'zhankai'
                }
            },
            typeOnScroll(e) {
                if (this.tabIndex == 0 && this.hushuTypeLoading || this.tabIndex == 1 && this.themeCategoryLoading) {
                    return;
                }

                let scrollHeight = e.target.scrollHeight;
                let clientHeight = e.target.clientHeight;
                let scrollTop = e.target.scrollTop;
                if (scrollHeight > clientHeight && scrollTop >= (scrollHeight - clientHeight - 5)) {
                    if (this.tabIndex == 0 && !this.typeListLoadend) {
                        this.fetchHuashuTypeList();
                    } else if (this.tabIndex == 1 && !this.themeCategoryLoadend) {
                        this.fetchWenanPackageCategoryList();
                    }
                }
            },
            huashuOnScroll(e) {
                if (this.tabIndex == 0 && (this.loading || this.searchLoading) || this.tabIndex == 1 && this
                    .wenanloading) {
                    return;
                }

                let scrollHeight = e.target.scrollHeight;
                let clientHeight = e.target.clientHeight;
                let scrollTop = e.target.scrollTop;
                if (scrollHeight > clientHeight && scrollTop >= (scrollHeight - clientHeight - 5)) {
                    if (this.tabIndex == 0 && !this.isSeaching && !this.huashuListLoadend) {
                        this.fetchHuashuList();
                    } else if (this.tabIndex == 0 && this.isSeaching && !this.searchLoadend) {
                        this.searchHuashu();
                    } else if (this.tabIndex == 1 && !this.wenanListLoadend) {
                        this.fetchWenanList();
                    }
                }
            },
            hideTeamList() {
                this.teamListShow = false;
            },
            async teamItemClick(idx) {
                this.isSeaching = false;
                this.keywords = "";
                this.teamSelIdx = idx;
                this.speechId = this.huashuTeamList[idx].speechId;
                localStorage.setItem("lastSelSpeechId", this.speechId)
                this.typePage = 1;
                this.typeSelIdx = 0;
                this.typeList = [];
                this.huashuPage = 1;
                this.huashuList = [];
                this.typeListLoadend = false;
                this.huashuListLoadend = false;
                await this.fetchHuashuTeamDetail();
                await this.fetchHuashuTypeList();
                this.fetchHuashuValList();
                this.teamListShow = false;
            },
            async themeItemClick(idx) {

                //切换文案包检查
                let params = {
                    themeId: this.themeList[idx].themeId
                }
                console.log("checkChangeWenanPackage params=", params);
                let resp = await this.$http.checkChangeWenanPackage(params)
                if (resp.code == 200) {
                    this.themeSelIdx = idx;
                    this.themeId = this.themeList[idx].themeId;
                    localStorage.setItem("lastSelThemeId", this.themeId)
                    this.themeCategoryPage = 1;
                    this.themeCategorySelIdx = 0;
                    this.themeCategoryList = [];
                    this.themeCategoryLoadend = false;
                    this.wenanPage = 1;
                    this.wenanList = [];
                    this.wenanListLoadend = false;
                    this.fetchWenanPackageCategoryList();
                    this.teamListShow = false;
                } else if (resp.code == 0) {
                    this.$message({
                        message: resp.message,
                        type: 'warning'
                    });
                } else if (resp.code == 8) {
                    this.$msgbox({
                        message: resp.message,
                        type: 'info'
                    });
                }
            },
            changeTeam() {
                this.teamListShow = true;
                this.xiaoguanShow = false;
            },
            toggleXiaoguanKeyboard() {
                this.teamListShow = false;
                this.xiaoguanShow = !this.xiaoguanShow;
                if (this.xiaoguanShow) {
                    this.fetchProductList();
                }
            },
            async fetchProductList() {
                try {
                    const resp = await this.$http.salesProductList({});
                    if (resp.code === 200 && resp.data && resp.data.array) {
                        this.productList = resp.data.array;
                    }
                } catch (e) {
                    console.log("获取产品列表失败:", e);
                }
            },
            hideXiaoguanKeyboard() {
                this.xiaoguanShow = false;
            },
            async pasteQuestionFromClipboard() {
                try {
                    const text = await navigator.clipboard.readText();
                    if (text) {
                        this.xiaoguanQuestion = text;
                    } else {
                        this.$message({ message: '剪贴板为空', type: 'warning' });
                    }
                } catch (e) {
                    console.log("read clipboard error:", e);
                    this.$message({ message: '读取剪贴板失败，请检查浏览器剪贴板权限', type: 'warning' });
                }
            },
            async xkCategoryClick(idx) {
                this.xkCategorySelIdx = idx;
                if (this.xkSegmentTab === 1 && this.xkSelProductIdx < 0) {
                    this.$message({ message: '未选择产品无法使用开场白，请去app上添加产品', type: 'warning' });
                    return;
                }
                if (this.xkSegmentTab === 0 && !this.xiaoguanQuestion.trim()) {
                    this.$message({ message: '请先填入问题', type: 'warning' });
                    return;
                }
                this.xkCategoryLoading = true;
                try {
                    const currentList = this.xkCurrentCategoryList;
                    const params = {
                        question: this.xiaoguanQuestion || currentList[idx].label,
                        talk_type: this.xkSegmentTab === 0 ? 40 : 41,
                        is_stream: 1,
                        keyword: currentList[idx].key,
                    };
                    if (this.xkSelProductIdx >= 0 && this.productList[this.xkSelProductIdx]) {
                        params.pid = this.productList[this.xkSelProductIdx].pid;
                    }
                    if (this.xkSelTeamIdx >= 0 && this.huashuTeamList[this.xkSelTeamIdx]) {
                        params.speechId = this.huashuTeamList[this.xkSelTeamIdx].speechId;
                    }
                    console.log("销冠键盘 AI对话 请求参数:", params);
                    const { ipcRenderer } = window.require("electron");
                    const resp = await ipcRenderer.invoke("keyboard-ai-chat", params);
                    console.log("销冠键盘 AI对话 返回结果:", resp);
                    if (resp?.code !== 200) {
                        this.$message({ message: resp?.message || "请求失败，请重试", type: "warning" });
                    } else {
                        const answer = resp?.data?.object?.answer;
                        if (answer) {
                            ipcRenderer.send("type-text", answer);
                        }
                    }
                } catch (e) {
                    console.log("销冠键盘 AI对话 请求失败:", e);
                }
                this.xkCategoryLoading = false;
            },
            openProductDialog() {
                this.xiaoguanShow = false;
                this.showProductDialog = true;
            },
            openHuashuSelectDialog() {
                this.xiaoguanShow = false;
                this.showHuashuSelectDialog = true;
            },
            onProductDialogClose() {
                this.xiaoguanShow = true;
            },
            onHuashuSelectDialogClose() {
                this.xiaoguanShow = true;
            },
            productItemClick(idx) {
                if (this.xkSelProductIdx === idx) {
                    this.xkSelProductIdx = -1;
                    this.xkSelProduct = "";
                } else {
                    this.xkSelProductIdx = idx;
                    this.xkSelProduct = this.productList[idx].name;
                }
                this.showProductDialog = false;
                this.xiaoguanShow = true;
            },
            addProduct() {
                this.showProductAddInput = true;
                this.$nextTick(() => {
                    const input = document.querySelector('.xkProductAddInputP .xkInput');
                    if (input) input.focus();
                });
            },
            confirmAddProduct() {
                if (this.newProductName.trim()) {
                    this.productList.push({
                        pid: Date.now(),
                        name: this.newProductName.trim(),
                        introduction: "",
                    });
                    this.newProductName = "";
                    this.showProductAddInput = false;
                }
            },
            xkTeamItemClick(idx) {
                if (this.xkSelTeamIdx === idx) {
                    this.xkSelTeamIdx = -1;
                } else {
                    this.xkSelTeamIdx = idx;
                }
                this.showHuashuSelectDialog = false;
                this.xiaoguanShow = true;
            },
            go2ImageList(idx) {
                console.log("go2ImageList....");
                //关闭悬浮窗
                this.huashuItemMouseleave();

                let item = this.huashuList[idx]
                localStorage.setItem("huashuData", JSON.stringify(item))
                this.$router.push({
                    path: '/imageList',
                    query: {
                        id: item.id
                    }
                })
            },
            huashuClick(idx) {
                this.typeSelIdx = idx;
                this.labelId = this.typeList[idx].labelId;
                this.huashuListLoadend = false;
                this.huashuPage = 1;
                this.huashuList = [];
                this.fetchHuashuList();
            },
            wenanCategoryClick(idx) {
                this.themeCategorySelIdx = idx;
                this.wenanLabelId = this.themeCategoryList[idx].labelId;
                this.wenanListLoadend = false;
                this.wenanPage = 1;
                this.wenanList = [];
                this.fetchWenanList();
            },
            // 图片元素转base64
            getBase64Image(img) {
                let canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx?.drawImage(img, 0, 0, img.width, img.height);
                let dataURL = canvas.toDataURL('image/png');
                return dataURL;
            },
            // 图片元素转base64
            getBase64(img) {
                let canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx?.drawImage(img, 0, 0, img.width, img.height);
                let dataURL = canvas.toDataURL('image/png');
                return dataURL;
            },
            // base64图片转为blob
            getBlobImage(dataurl) {
                let arr = dataurl.split(',');
                let mime = arr[0].match(/:(.*?);/)[1];
                let bstr = atob(arr[1]);
                let n = bstr.length;
                let u8arr = new Uint8Array(n);
                while (n--) {
                  u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
            // 复制图片
            async copyImage(imageUrl) {
                return new Promise(async (resolve,reject)=>{
                    // let dataurl = this.getBase64Image(dom);
                    // let blob = this.getBlobImage(dataurl);
                    // const blob = await fetch(imageUrl).then(r => r.blob());


                    fetch(imageUrl)
                    .then((response) => {
                        if (response.ok) {
                        return response.blob();
                        }
                    })
                    .then((blob) => {
                        return new Promise((resolve, reject) => {
                        let img = document.createElement('img');
                        img.onload = () => {
                            let canvas = document.createElement('canvas');
                            let ctx = canvas.getContext('2d');
                            canvas.width = img.width;
                            canvas.height = img.height;
                            ctx.drawImage(img, 0, 0, img.width, img.height);
                            canvas.toBlob(resolve, 'image/png');
                        };
                        img.onerror = reject;
                        img.src = URL.createObjectURL(blob);
                        });
                    })
                    .then((pngBlob) => {
                        let data = [new window.ClipboardItem({ [pngBlob.type]: pngBlob })];
                        navigator.clipboard.write(data);
                        resolve();
                    })
                    .then(() => {
                        console.log('Image copied to clipboard successfully');
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });


                    // navigator.clipboard.write([
                    // new window.ClipboardItem({
                    //     [blob.type]: blob
                    // })
                    // ]).then(()=>{
                    //     console.log("图片复制成功");
                    //     resolve();
                    // }, (err)=> {
                    //     console.log('图片复制失败！ err:',err);
                    //     resolve();
                    // });
                })
            },
            //去除字符串中的html标签
            stripHtmlTags(html) {
                // 将换行符占位符临时替换为特殊标记
                const withPlaceholders = html.replace(/\\n/g, '___NEWLINE___');
                
                // 去除HTML标签
                const withoutTags = withPlaceholders.replace(/<[^>]*>/g, '');
                
                // 将特殊标记恢复为换行符
                return withoutTags.replace(/___NEWLINE___/g, '\n');
            },
            itemClick(idx,isDbl=false) {
                //隐藏提示窗
                this.huashuItemMouseleave();

                let item = this.showHuashuList[idx]
                let text=this.stripHtmlTags(item.allText);
                if(item.isCarryTitle){
                    text=item.title+'\n'+text
                }else if(!text.trim().length){
                    // this.$message({
                    //     message: '话术无内容',
                    //     type: 'warning'
                    // });
                    return;
                }

                if(this.itemClickTimer){
                    clearTimeout(this.itemClickTimer)
                    this.itemClickTimer=null;
                }
                this.itemClickTimer=setTimeout(async ()=>{
                    navigator.clipboard.writeText(text).then(() => {
                        this.$message({
                            message: '文本已复制',
                            type: 'success'
                        });
                        console.log("item.text==", item.allText);
                        const {
                            ipcRenderer
                        } = window.require('electron');
                        // this.autoPartSend(item);
                        // let tmpEleIdx = 0;
                        // let autoTimer = setInterval(async ()=>{
                        //     if(tmpEleIdx>=item.eleList.length){
                        //         clearInterval(autoTimer)
                        //         autoTimer=null;
                        //         return;
                        //     }
                        //     if(item.eleList[tmpEleIdx].type=='text'){
                        //         ipcRenderer.send('type-text', item.eleList[tmpEleIdx].val,isDbl);
                        //     }else{
                        //         await this.copyImage(item.eleList[tmpEleIdx].val);
                        //         ipcRenderer.send('type-img');
                        //     }
                            
                        //     tmpEleIdx++;
                        // },1000)
                        ipcRenderer.send('type-text', text,isDbl);
                    }, function () {
                        console.log('文件复制失败！');
                    });
                },300)
            },
            wenanItemClick(idx,isDbl=false) {
                if(this.itemClickTimer){
                    clearTimeout(this.itemClickTimer)
                    this.itemClickTimer=null;
                }
                this.itemClickTimer=setTimeout(()=>{
                    let item = this.wenanList[idx]
                    navigator.clipboard.writeText(item.text).then(() => {
                        // if(this.tools.isElectron){
                        this.$message({
                            message: '文本已复制',
                            type: 'success'
                        });
                        console.log("item.text==", item.text);
                        const {
                            ipcRenderer
                        } = window.require('electron');
                        ipcRenderer.send('type-text', item.text,isDbl);
                        // }
                    }, function () {
                        console.log('文件复制失败！');
                    });
                },300)
            },
            async fetchData() {
                if (this.tabIndex == 0) {
                    await this.fetchHuashuTeamList();
                } else {
                    await this.fetchDefaultWenanPackageList()
                    this.fetchWenanPackageList();
                }
            },
            //查询话术变量列表
            fetchHuashuValList(){
                return new Promise(async (resolve,reject)=>{
                    let params = {
                        speechId:this.speechId,
                    }
                    console.log("fetchHuashuValList params=", params);
                    let resp = await this.$http.fetchHuashuValList(params)
                    if (resp.code == 200) {
                        this.huashuValList = resp.data.array;
                    }
                    resolve();
                })
            },
            //查询默认文案包列表
            async fetchDefaultWenanPackageList() {
                return new Promise(async (resolve, reject) => {
                    let params = {}
                    console.log("wenanPackageList params=", params);
                    let resp = await this.$http.defaultWenanPackageList(params)
                    if (resp.code == 200) {
                        this.defaultThemeList = [resp.data.object];
                    }
                    resolve();
                })
            },
            //查询文案包列表
            async fetchWenanPackageList() {
                let params = {
                    page: this.themePage,
                    pageSize: this.themePageSize,
                    type: 1,
                }
                console.log("wenanPackageList params=", params);
                let resp = await this.$http.wenanPackageList(params)
                console.log("wenanPackageList resp:", resp)
                if (resp.code === 200) {
                    if (this.themePage == 1 && resp.data.array && !resp.data.array.length) {
                        // this.themeList.splice(this.themeList.length,0,resp.data.array)
                        this.themeList = this.defaultThemeList;
                    } else if (resp.data.array && resp.data.array.length) {
                        this.themeList = resp.data.array;
                    }

                    if (localStorage.getItem("lastSelThemeId")) {
                        this.themeId = localStorage.getItem("lastSelThemeId");
                        this.themeList.forEach((theme, idx) => {
                            if (this.themeId == theme.themeId) {
                                this.themeSelIdx = idx;
                            }
                        })
                    } else {
                        this.themeId = this.themeList[0].themeId;
                    }
                    // else if(!this.themeList.length&&resp.data.array.length){
                    //     this.themeId=this.themeList[0].themeId;
                    // }
                    // this.themeList=resp.data.array;
                    if (this.themeList && this.themeList.length) {
                        this.fetchWenanPackageCategoryList();
                    }
                    // else{
                    //     this.$msgbox({
                    //         message: '暂无文案包，请到微脉输入法App文案广场添加',
                    //         type: 'info'
                    //     }).then(() => {
                    //         this.tabClick(0)
                    //     });
                    // }
                } else {
                    this.$message({
                        message: resp.message,
                        type: 'warning'
                    });
                }
            },
            //查询文案包分类列表
            async fetchWenanPackageCategoryList() {
                this.themeCategoryLoading = true;
                let params = {
                    page: this.themeCategoryPage,
                    pageSize: this.themeCategoryPageSize,
                    themeId: this.themeId,
                }
                console.log("wenanCategoryList params=", params);
                let resp = await this.$http.wenanCategoryList(params)
                console.log("wenanCategoryList resp:", resp)
                if (resp.code === 200) {
                    if (resp.data.array.length < this.themeCategoryPageSize) {
                        this.themeCategoryLoadend = true;
                    }
                    if (resp.data.array.length) {
                        this.themeCategoryList.splice(this.themeCategoryList.length, 0, ...resp.data.array);
                    }
                    if (this.themeCategoryList.length && this.themeCategoryPage == 1) {
                        this.wenanLabelId = this.themeCategoryList[0].labelId;
                        this.fetchWenanList();
                    }
                    this.themeCategoryPage++;
                } else {
                    this.$message({
                        message: resp.message,
                        type: 'warning'
                    });
                }
                this.themeCategoryLoading = false;
            },
            //查询文案列表
            async fetchWenanList() {
                this.wenanloading = true;
                let params = {
                    page: this.wenanPage,
                    pageSize: this.wenanPageSize,
                    themeId: this.themeId,
                    labelId: this.wenanLabelId,
                }
                console.log("wenanList params=", params);
                let resp = await this.$http.wenanList(params)
                console.log("wenanList resp:", resp)
                if (resp.code === 200) {
                    if (resp.data.array.length < this.wenanPageSize) {
                        this.wenanListLoadend = true;
                    }
                    if (resp.data.array.length) {
                        // resp.data.array=resp.data.array.map((val)=>{
                        //     val.eleList=this.generateEleList(val.speechText);
                        //     val.imglist=val.eleList.filter((eleListItem)=>{
                        //         eleListItem.val=eleListItem.val.replace("http://","https://")
                        //          return eleListItem.type=='img'||eleListItem.type=='video'
                        //     })
                        //     val.filelist=val.eleList.filter((eleListItem)=>{
                        //         eleListItem.val=eleListItem.val.replace("http://","https://")
                        //          return eleListItem.type=='file'||eleListItem.type=='audio'
                        //     })
                        //     val.allText=this.getEleListAllText(val.eleList);
                        //     return val;
                        // })
                        this.wenanList.splice(this.wenanList.length, 0, ...resp.data.array);
                    }
                    if (this.wenanList.length && this.wenanPage == 1) {
                        this.wenanId = this.wenanList[0].libraryId;
                    }
                    this.wenanPage++;
                } else {
                    this.$message({
                        message: resp.message,
                        type: 'warning'
                    });
                }
                this.updateCellStyle();
                this.wenanloading = false;
            },
            async fetchHuashuTeamList() {
                return new Promise(async (resolve,reject)=>{
                    let params = {}
                    console.log("fetchHuashuTeamList params=", params);
                    let resp = await this.$http.qryHuashuTeamList(params)
                    console.log("fetchHuashuTeamList resp:", resp)
                    if (resp.code === 200) {
                        if(!resp.data.array.length){
                            this.$message({
                                message: "未检测到话术团队，请在app端加入团队再使用",
                                type: 'error'
                            });
                            return
                        }
                        if (localStorage.getItem("lastSelSpeechId")) {
                            this.speechId = localStorage.getItem("lastSelSpeechId");
                            resp.data.array.forEach((team, idx) => {
                                if (this.speechId == team.speechId) {
                                    this.teamSelIdx = idx;
                                }
                            })
                        } else if (!this.huashuTeamList.length && resp.data.array.length) {
                            this.speechId = resp.data.array[0].speechId;
                        }

                        this.huashuTeamList = resp.data.array;
                        if (resp.data.array && resp.data.array.length) {
                            await this.fetchHuashuTeamDetail()
                            await this.fetchHuashuValList();
                            await this.fetchHuashuTypeList();
                        }
                    } else {
                        this.$message({
                            message: resp.message,
                            type: 'warning'
                        });
                    }
                    resolve();
                })
            },
            async fetchHuashuTeamDetail() {
                return new Promise(async (resolve, reject) => {
                    this.hushuTypeLoading = true;
                    let params = {
                    speechId: this.speechId,
                    };
                    console.log("fetchHuashuTeamDetail params=", params);
                    let resp = await this.$http.fetchHuashuTeamDetail(params);
                    console.log("fetchHuashuTeamDetail resp:", resp);
                    if (resp.code === 200) {
                    this.currentHuashuTeamInfo = resp.data.object;
                    } else {
                    this.$message({
                        message: resp.message,
                        type: "warning",
                    });
                    }
                    resolve();
                });
            },
            async fetchHuashuTypeList() {
                return new Promise(async (resolve,reject)=>{
                    this.hushuTypeLoading = true;
                    let params = {
                        page: this.typePage,
                        pageSize: this.typePageSize,
                        speechId: this.speechId,
                    }
                    console.log("qryHuashuTypeList params=", params);
                    let resp = await this.$http.qryHuashuTypeList(params)
                    console.log("qryHuashuTypeList resp:", resp)
                    if (resp.code === 200) {

                        if (this.currentHuashuTeamInfo&&this.currentHuashuTeamInfo.hideLabelIds&&
            this.currentHuashuTeamInfo.roleId != 2) {
                            let hideLabelIds = JSON.parse(
                                this.currentHuashuTeamInfo.hideLabelIds
                            );
                            hideLabelIds.forEach((hideTypeItem) => {
                                resp.data.array.forEach((typeIteam) => {
                                    if (typeIteam.labelId == hideTypeItem) {
                                        typeIteam.hide = true;
                                    }
                                });
                            });
                            resp.data.array = resp.data.array.filter((typeIteam) => {
                                return !typeIteam.hide;
                            });
                        }

                        
                        if (resp.data.array.length < this.typePageSize) {
                            this.typeListLoadend = true;
                        }
                        if (resp.data.array.length) {
                            this.typeList.splice(this.typeList.length, 0, ...resp.data.array);
                        }
                        if (this.typeList.length && this.typePage == 1) {
                            this.labelId = this.typeList[0].labelId;
                            await this.fetchHuashuList();
                        }
                        this.typePage++;
                    } else {
                        this.$message({
                            message: resp.message,
                            type: 'warning'
                        });
                    }
                    this.hushuTypeLoading = false;
                    resolve();
                })
            },
            async fetchHuashuList() {
                return new Promise(async (resolve,reject)=>{
                    this.loading = true;
                    let params = {
                        page: this.huashuPage,
                        pageSize: this.huashuPageSize,
                        speechId: this.speechId,
                        labelId: this.labelId,
                    }
                    console.log("qryHuashuList params=", params);
                    let resp = await this.$http.qryHuashuList(params)
                    console.log("qryHuashuList resp:", resp)
                    if (resp.code === 200) {
                        if (resp.data.array.length < this.huashuPageSize) {
                            this.huashuListLoadend = true;
                        }
                        if (resp.data.array.length) {
                            resp.data.array = resp.data.array.map((val) => {
                                //替换话术变量
                                val.speechText = this.replaceHuashuBianliang(val.speechText)
                                val.speechText = this.convertColorTags(val.speechText);
                                val.eleList = this.generateEleList(val.speechText);
                                val.imglist = val.eleList.filter((eleListItem) => {
                                    eleListItem.val = eleListItem.val.replace("http://", "https://")
                                    return eleListItem.type == 'img' || eleListItem.type == 'video'
                                })
                                val.filelist = val.eleList.filter((eleListItem) => {
                                    eleListItem.val = eleListItem.val.replace("http://", "https://")
                                    return eleListItem.type == 'file' || eleListItem.type == 'audio'
                                })
                                val.allText = this.getEleListAllText(val.eleList);
                                return val;
                            })
                            this.huashuList.splice(this.huashuList.length, 0, ...resp.data.array);
                            this.countTopHuashu = this.huashuList.filter((val) => {
                                return val.isTop
                            }).length;
                            if (this.huashuTopBarShow) {
                                this.showHuashuList = this.huashuList;
                            } else {
                                this.showHuashuList = this.huashuList.filter((huashu) => {
                                    return !huashu.isTop
                                });
                            }
                        }
                        if (this.huashuList.length && this.huashuPage == 1) {
                            this.huashuDetailId = this.huashuList[0].id;
                        }
                        this.huashuPage++;
                    } else {
                        this.$message({
                            message: resp.message,
                            type: 'warning'
                        });
                    }
                    this.updateCellStyle();
                    this.loading = false;
                    resolve();
                })
            },
            convertColorTags(html) {
                // 使用正则全局替换所有匹配的标签
                return html.replace(
                    /<标记颜色开始(#(?:[\da-fA-F]{3}){1,2})>([\s\S]*?)<\/标记颜色结束>/gi,
                    (match, colorCode, content) => {
                    return `<span style="color: ${colorCode}">${content}</span>`;
                    }
                );
            },
            updateCellStyle() {
                setTimeout(() => {
                    let list = []
                    if (this.tabIndex == 0) {
                        list = JSON.parse(JSON.stringify(this.showHuashuList))
                    } else {
                        list = JSON.parse(JSON.stringify(this.wenanList))
                    }
                    list.forEach((item) => {
                        let id = this.tabIndex == 0 ? item.id : item.libraryId;
                        if (this.$refs[id]) {
                            let ele = this.$refs[id][0];
                            let showEle = this.$refs['show' + id][0];
                            let shouqiHeight = this.wenanShowLineCount * 20 - 1;
                            if (ele.clientHeight > shouqiHeight && ele.clientHeight > showEle
                                .clientHeight) {
                                item.showBtn = 'zhankai';
                            } else {
                                item.showBtn = '';
                            }
                            // console.log("ele:",ele);
                        }
                    })
                    if (this.tabIndex == 0) {
                        this.showHuashuList = list;
                    } else {
                        this.wenanList = list;
                    }
                }, 1)
            },
            replaceAll(string, search, replace) {
                return string.split(search).join(replace);
            },
            generateEleList(speechText) {
                let eleList = []
                let _this = this;
                let text = speechText;
                // text = this.replaceAll(text, "<分段>\n", "");
                // text = this.replaceAll(text, "<分段>", "\n");
                text = this.replaceAll(text, "\n<连行开始>", "");
                text = this.replaceAll(text, "</连行结束>\n", "");
                text = this.replaceAll(text, "<连行开始>", "");
                text = this.replaceAll(text, "</连行结束>", "");
                // text = this.replaceAll(text, "\n", "\n\n");
                text=text.replace(/<\/?标记颜色开始#[0-9a-fA-F]{6}>/g, '');

                const urlRegex =
                    /https?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]\.(png|jpg|jpeg|pdf|docx|doc|dotm|xlsx|xls|mp4|mov|mp3|m4a|aac|caf|pptx|ppt|txt)/gi;
                const urls = [];
                let match;
                let lastPart = text;

                while ((match = urlRegex.exec(text)) !== null) {
                    let url = match[0];
                    const fileExtension = this.getFileExtension(url);

                    // 只添加具有正确文件后缀的URL
                    if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg' ||
                        fileExtension === 'pdf' || fileExtension === 'doc' || fileExtension === 'docx' ||
                        fileExtension === 'dotm' || fileExtension === 'dotx' || fileExtension === 'dotm' ||
                        fileExtension === 'txt' || fileExtension === 'xlsx' || fileExtension === 'xls' ||
                        fileExtension === 'mp4' || fileExtension === 'mov' || fileExtension === 'mp3' ||
                        fileExtension === 'm4a' || fileExtension === 'aac' || fileExtension === 'caf' ||
                        fileExtension === 'ppt' || fileExtension === 'pptx') {
                        let tmp = lastPart.split(url);
                        // console.log("tmp==",tmp[0]);
                        eleList.push({
                            type: "text",
                            val: tmp[0],
                        })
                        if (fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                            eleList.push({
                                type: "img",
                                val: url,
                            })
                            // this.imgUrlList.push(url)
                        } else if (fileExtension === 'mp4') {
                            eleList.push({
                                type: "video",
                                val: url,
                            })
                        } else if (fileExtension === 'mp3' || fileExtension === 'm4a') {
                            let eleIdx = eleList.length;
                            let tmpUrl = new URL(url);
                            let fileName = tmpUrl.pathname.split('/').pop();
                            let audio = new Audio();
                            audio.src = url;
                            audio.id = "audio" + eleIdx;
                            let id = new Date().getTime();
                            eleList.push({
                                type: "audio",
                                val: url,
                                fileName: fileName,
                                fileIcon: this.getFileIcon(fileName),
                                id: id
                            })
                        } else {
                            let tmpUrl = new URL(url);
                            const fileName = tmpUrl.pathname.split('/').pop();
                            eleList.push({
                                type: "file",
                                val: url,
                                fileName: fileName,
                                fileIcon: this.getFileIcon(fileName)
                            })
                        }
                        // lastPart=tmp[1]
                        let str = ""
                        tmp.forEach((tmpItem, idx) => {
                            if (idx) {
                                str += tmpItem
                            }
                        })
                        lastPart = str;
                    }
                }
                eleList.push({
                    type: "text",
                    val: lastPart,
                })
                return eleList
            },
            getEleListAllText(eleList) {
                let text = "";
                eleList.forEach((ele,idx) => {
                    if (ele.type == "text") {
                        // 处理文本元素
                        // if(idx>0&&eleList[idx-1].type!="text"&&ele.val.substr(0,1)=='\n'){
                        //     ele.val = ele.val.substr(1)
                        // }
                        let tmp = this.replaceAll(ele.val, "<分段>\n", "");
                        tmp = this.replaceAll(tmp, "<分段>", "\n");
                        text += tmp;
                    }
                })
                return text;
            },
            // 提取文件后缀的辅助函数
            getFileExtension(url) {
                const path = url.split('/');
                const fileName = path[path.length - 1];
                const parts = fileName.split('.');

                if (parts.length > 1) {
                    return parts.pop();
                }

                return '';
            },
            getVideoDuration(url) {
                let video = document.createElement('video');
                video.src = url;
                video.load();
                video.onload = () => {
                    console.log("video==", video);
                }
            },
            getFileIcon(fileName) {
                let icon = ""
                if (fileName.includes(".doc")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143256.png"
                } else if (fileName.includes(".txt")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143245.png"
                } else if (fileName.includes(".xls")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143214.png"
                } else if (fileName.includes(".mp3") || fileName.includes(".m4a")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114041.png"
                } else if (fileName.includes(".pdf")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114100.png"
                } else if (fileName.includes(".ppt") || fileName.includes(".pptx")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230608114321.png"
                } else {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230601152642.png"
                }
                return icon;
            },
            //滚轮左右滑动
            wheelHScroll(event){
                event.preventDefault();
                // 根据滚轮的垂直滚动值设置水平滚动
                event.currentTarget.scrollLeft += event.deltaY;
            },
            openSortDialog(){
                this.sortTypeList = JSON.parse(JSON.stringify(this.typeList));
                this.sortDialogVisible = true;
            },
            closeSortDialog(){
                this.sortDialogVisible = false;
                this.sortTypeList = [];
                this.dragIndex = -1;
                this.dragOverIndex = -1;
            },
            onSortDragStart(index){
                this.dragIndex = index;
            },
            onSortDragOver(index){
                this.dragOverIndex = index;
            },
            onSortDrop(index){
                if (this.dragIndex === index || this.dragIndex < 0) return;
                const list = this.sortTypeList;
                const item = list[this.dragIndex];
                const newList = list.filter((_, i) => i !== this.dragIndex);
                newList.splice(index, 0, item);
                this.sortTypeList = newList;
                this.dragIndex = -1;
                this.dragOverIndex = -1;
            },
            onSortDragEnd(){
                this.dragIndex = -1;
                this.dragOverIndex = -1;
            },
            async saveSortOrder(){
                const orderChanged = this.sortTypeList.some((item, index) => item.labelId !== this.typeList[index].labelId);
                if (!orderChanged) {
                    this.closeSortDialog();
                    return;
                }
                const resp = await this.$http.sortHushuType({
                    speechId: this.speechId,
                    labelIdArray: this.sortTypeList.map((item, index) => item.labelId)
                });
                if (resp.code == 200) {
                    this.typeList = JSON.parse(JSON.stringify(this.sortTypeList));
                    this.closeSortDialog();
                } else {
                    this.$message({ message: resp.message, type: 'warning' });
                }
            },
        },
        async created() {
            console.log("created...");
            if(localStorage.getItem("localDataVersion")!=this.$config.localDataVersion){
                localStorage.setItem("localDataVersion",this.$config.localDataVersion)
                // localStorage.clear();
                localStorage.removeItem("syncParamsList")
                await dbService.clearAllData();
                return;
            }


            await dbService.initDb();
            this.localHuashuListData = await dbService.getAllData("huashuList")
            if (localStorage.getItem("huashuTopBarHide")) {
                this.huashuTopBarShow = false;
            }
            // if (localStorage.getItem("wenanShowLineCount")) {
            //     this.wenanShowLineCount = parseInt(localStorage.getItem("wenanShowLineCount"));
            // }
            window.addEventListener('resize', () => {
                this.pageWidth = window.innerWidth || document.documentElement.clientWidth || document.body
                    .clientWidth;
                this.pageHeight = window.innerHeight || document.documentElement.clientHeight || document.body
                    .clientHeight;
            })
            this.faceIcon = localStorage.getItem("edujia:group:web:faceIcon")
            if (localStorage.getItem("edujia:group:web:token")) {
                this.$store.commit('modifyToken', localStorage.getItem("edujia:group:web:token"))
            }
            if (localStorage.getItem('typeListWidth')) {
                this.typeListWidth = localStorage.getItem('typeListWidth')
            }
        },
        mounted() {
            console.log("mounted...");
            if(window.require){
                const { ipcRenderer } = window.require('electron');
                ipcRenderer.send('getSettingInfo');
                let _this=this;
                ipcRenderer.on('webLog', (event, logStr) => {
                    this.$message('logStr:'+logStr);
                })
                ipcRenderer.on('getSettingInfoResp', (event, settingInfoStr) => {
                    if(settingInfoStr){
                        _this.$store.commit('modifySettingInfo',JSON.parse(settingInfoStr));
                    }
                })
                ipcRenderer.on('updateHuashuItem', (event, huashuItem) => {
                    console.log("updateHuashuItem:",huashuItem)
                    huashuItem.eleList = _this.generateEleList(huashuItem.speechText);
                    huashuItem.imglist = huashuItem.eleList.filter((eleListItem) => {
                        eleListItem.val = eleListItem.val.replace("http://", "https://")
                        return eleListItem.type == 'img' || eleListItem.type == 'video'
                    })
                    huashuItem.filelist = huashuItem.eleList.filter((eleListItem) => {
                        eleListItem.val = eleListItem.val.replace("http://", "https://")
                        return eleListItem.type == 'file' || eleListItem.type == 'audio'
                    })
                    huashuItem.allText = _this.getEleListAllText(huashuItem.eleList);
                    let resultIdx = -1;
                    _this.huashuList.forEach((val, idx) => {
                        if (huashuItem.id == val.id) {
                            resultIdx = idx;
                        }
                    })
                    if (resultIdx != -1) {
                        huashuItem.isTop=_this.huashuList[resultIdx].isTop;
                        _this.huashuList.splice(resultIdx, 1, huashuItem)
                    } else if (huashuItem.isTop == 1&&huashuItem.isFront == 1) {
                        _this.huashuList.splice(0, 0, huashuItem)    
                    } else if(huashuItem.isTop == 1&&huashuItem.isFront == 2){
                        _this.huashuList.splice(_this.countTopHuashu, 0, huashuItem)
                    }else if(huashuItem.isFront == 1){
                        _this.huashuList.splice(_this.countTopHuashu, 0, huashuItem)
                    }else {
                        _this.huashuList.splice(_this.huashuList.length, 0, huashuItem)
                    }
                    // if(this.huashuListLoadend){
                    //     this.huashuList.splice(this.huashuList.length,0,huashuItem)
                    // }
                    _this.updateCellStyle();
                })
                
            }
            this.$refs.topSubP.addEventListener('wheel', this.wheelHScroll);
            this.$refs.bottomBarP.addEventListener('wheel', this.wheelHScroll);
        },
        activated() {
            console.log("activated...");
            if (localStorage.getItem("needReresh")) {
                this.typePage = 1;
                this.typeListLoadend = false;
                this.typeList = [];
                localStorage.removeItem("needReresh");
            }
            this.fetchData();
            // if (localStorage.getItem("updateHuashuItem")) {
            //     let huashuItem = JSON.parse(localStorage.getItem("updateHuashuItem"))
            //     huashuItem.eleList = this.generateEleList(huashuItem.speechText);
            //     huashuItem.imglist = huashuItem.eleList.filter((eleListItem) => {
            //         eleListItem.val = eleListItem.val.replace("http://", "https://")
            //         return eleListItem.type == 'img' || eleListItem.type == 'video'
            //     })
            //     huashuItem.filelist = huashuItem.eleList.filter((eleListItem) => {
            //         eleListItem.val = eleListItem.val.replace("http://", "https://")
            //         return eleListItem.type == 'file' || eleListItem.type == 'audio'
            //     })
            //     huashuItem.allText = this.getEleListAllText(huashuItem.eleList);
            //     let resultIdx = -1;
            //     this.huashuList.forEach((val, idx) => {
            //         if (huashuItem.id == val.id) {
            //             resultIdx = idx;
            //         }
            //     })
            //     if (resultIdx != -1) {
            //         huashuItem.isTop=this.huashuList[resultIdx].isTop;
            //         this.huashuList.splice(resultIdx, 1, huashuItem)
            //     } else if (huashuItem.isFront == 1) {
            //         this.huashuList.splice(this.countTopHuashu, 0, huashuItem)
            //     } else {
            //         this.huashuList.splice(this.huashuList.length, 0, huashuItem)
            //     }
            //     // if(this.huashuListLoadend){
            //     //     this.huashuList.splice(this.huashuList.length,0,huashuItem)
            //     // }
            //     localStorage.removeItem("updateHuashuItem");
            //     this.updateCellStyle();
            // }
        },
    }
</script>

<style>
    .el-dialog__body {
        padding: 10px 20px;
    }

    /* 隐藏垂直滚动条 */
    /* ::-webkit-scrollbar {
        width: 0;
    } */
    
    /* 隐藏水平滚动条 */
    /* ::-webkit-scrollbar {
        height: 0;
    } */

    .el-message-box {
        display: inline-block;
        width: 80%;
        min-width: 200px;
        max-width: 300px;
        padding-bottom: 10px;
        vertical-align: middle;
        background-color: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #EBEEF5;
        font-size: 18px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        text-align: left;
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }

    /* ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    ::-webkit-scrollbar-button, ::-webkit-scrollbar-corner {
        background: none;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: lightgray;
        transition: 0.3s ease-in-out;
    }

    ::-webkit-scrollbar-track {
        background: none;
    } */
</style>

<style scoped>
    .top {
        padding-bottom: 8px;
        /*    height: 32px;*/
        height: 74px;
        padding-top: 40px;
        box-shadow: 0 2px 4px 0 #e5e5e58a;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        min-width: 200px;
    }

    .topSubP {
        width: 100%;
        /* overflow-x: scroll; */
        overflow-x: auto;
        overflow-y: hidden;
    }

    .topSub {
        display: flex;
        justify-content: space-between;
        min-width: 380px;
    }

    .topLLP {
        margin-left: 16px;
        display: flex;
        align-items: center;
        min-width: 240px;
    }

    .topLLItem {}

    .topLLItemSel {
        color: #FB5D5C;
        font-size: 16px;
    }

    .topLLItemLine {
        width: 1px;
        height: 16px;
        background-color: #BDBDBD;
        margin-left: 8px;
        margin-right: 8px;
    }

    .topLLItem span {
        font-size: 14px;
        font-weight: 500;
    }

    .topLLItem div {
        width: 24px;
        height: 2px;
        border-radius: 2px;
        margin-top: 2px;
        background-color: #FB5D5C;
        margin: auto;
    }

    .topL {
        display: flex;
        align-items: center;
    }

    .topLL {
        width: 20px;
        height: 20px;
        margin-left: 14px;
    }

    .topLR {
        font-size: 14px;
        font-weight: 500;
        color: #3c3c3c;
        margin-left: 8px;
        max-width: 150px;
        height: 32px;
        line-height: 32px;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .topRP {
        display: flex;
        align-items: center;
        min-width: 170px;
    }

    .topRR2 {
        display: flex;
    }

    .topR {
        display: flex;
        align-items: center;
        /*    margin-right: 16px;*/
    }

    .topRL {
        width: 14px;
        height: 15px;
        margin-left: 14px;
    }

    .topRR {
        margin-left: 8px;
        color: #4A90E2;
        font-size: 14px;
        /*    padding-right: 20px;*/
        /*    border-right: 1px solid #BDBDBD;*/
    }

    .content {
        display: flex;
        /*    padding-top: 83px;*/
        padding-top: 125px;
    }

    .typeList {
        /*    width: 144px;*/
        min-width: 50px;
        max-width: 200px;
        background-color: #F5F6F6;
        overflow: scroll;
    }

    .typeList::-webkit-scrollbar {
        width: 0px !important;
        height: 0px !important;
    }


    .typeListItem {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: #F5F6F6;
        font-size: 14px;
        color: #3C3C3C;
        padding-left: 14px;
    }

    .typeListItem div {
        /*    width: 112px;*/
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .typeListItemSel {
        background-color: #fff;
        color: #FB5D5C;
        font-weight: 500;
    }

    .huashuList {
        /*    width: 77%;*/
        overflow: scroll;
        flex: 1;
        position: relative;
    }

    .huashuListItem {
        padding: 8px 8px 8px 0px;
        /* border-bottom: 1px solid #E5E5E5; */
        padding-left: 8px;
        position: relative;
        line-height: 1.2;
    }

    .huashuListItemTop {
        display: flex;
        align-items: center;
    }

    .huashuListItemTopL {
        width: 20px;
        height: 20px;
    }

    .huashuListItemTopM {
        /* margin-left: 4px; */
        /* margin-right: 8px; */
        font-size: 14px;
        line-height: 25px;
        font-weight: 500;
        color: #4A90E2;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 90%;
        white-space: nowrap;
    }

    .huashuListItemTopMBig {
        font-size: 16px;
        font-weight: bold;
        margin-left: 0;
    }

    .huashuListItemTopR {
        margin-right: 8px;
        width: 24px;
        height: 24px;
    }

    .actionBtn {
        color: #4A90E2;
        font-size: 14px;
    }

    .huashuListItemDetailP {
        /* border-bottom: 1px solid #E5E5E5; */
        padding-bottom: 16px;
    }

    .huashuListItemDetail {
        font-size: 13px;
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 20px;
        min-height: 20px;
    }

    .huashuListItemDetailShowmore {
        margin-top: 4px;
        font-size: 14px;
        white-space: pre-wrap;
    }

    .huashuListItemDetailNoHide {
        margin-top: 4px;
        font-size: 14px;
        white-space: pre-wrap;
        position: absolute;
        /*left: -10000px;
    bottom: -10000px;*/
        left: 0;
        top: 0;
        opacity: 0;
        line-height: 20px;
        pointer-events: none;
    }

    .teamListCover {
        position: absolute;
        top: 79px;
        left: 0;
        width: 100%;
        background-color: #fff;
        border-radius: 0 0 8px 8px;
        box-shadow: 0 4px 8px 0 #e5e5e580;
        z-index: 99999;
    }

    .teamListP {
        display: flex;
        justify-content: center;
    }

    .teamList {
        width: 89.74%;
        display: flex;
        flex-wrap: wrap;
    }

    .teamListItem {
        width: 33%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #E5E5E5;
        background-color: #F5F6F6;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #3C3C3C;
        font-size: 14px;
        flex-basis: calc(33.33% - 20px);
        /* 让每个子元素等分，这里假设有3个子元素，减去10px的间隔 */
        margin: 10px;
        /* 添加间隔 */
        box-sizing: border-box;
        position: relative;
    }

    .teamListItem img {
        position: absolute;
        left: 0;
        top: 0;
        width: 16px;
        height: 16px;
    }

    .teamListItem div {
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 80%;
        overflow: hidden;
        text-align: center;
    }

    .teamListItemSel {
        border-color: #FB5D5C;
        background-color: #FFF6F6;
        color: #FB5D5C;
    }

    .shouqiBtnP {
        display: flex;
        justify-content: center;
    }

    .shouqiBtn {
        color: #4A90E2;
        font-size: 14px;
        display: flex;
        align-items: center;
        margin: auto;
    }

    .shouqiBtn img {
        width: 14px;
        height: 8px;
        margin-left: 4px;
    }

    .xkTopBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 32px 0;
        flex-wrap: nowrap;
    }

    .xkSegmentBar {
        display: flex;
        padding: 16px 32px 0;
    }

    .xkSegmentTab {
        padding: 6px 20px;
        border-radius: 4px;
        background: #F5F6F6;
        color: #3C3C3C;
        font-size: 14px;
        cursor: pointer;
        margin-right: 12px;
    }

    .xkSegmentTabSel {
        background: #FB5D5C;
        color: #fff;
    }

    .xkInputP {
        width: 55%;
    }

    .xkInputHint {
        display: flex;
        align-items: center;
        color: #3C3C3C;
        font-size: 14px;
    }

    .xkInput {
        width: 100%;
        height: 36px;
        border: 1px solid #E5E5E5;
        border-radius: 4px;
        background-color: #F5F6F6;
        padding: 0 12px;
        font-size: 14px;
        color: #3C3C3C;
        outline: none;
        box-sizing: border-box;
    }

    .xkInput::placeholder {
        color: #999999;
    }

    .xkCheckboxP {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    .xkCheckboxItem {
        display: flex;
        align-items: center;
        margin-left: 24px;
        cursor: pointer;
        color: #3C3C3C;
        font-size: 14px;
        max-width: 160px;
    }

    .xkCheckboxItem span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .xkCheckboxItem:hover {
        color: #FB5D5C;
    }

    .xkCheckboxItemSel {
        color: #FB5D5C;
    }

    .xkArrowIcon {
        width: 10px;
        height: 6px;
        margin-left: 4px;
        transform: rotate(180deg);
    }


    .xkCategoryList {
        margin-top: 4px;
        padding-bottom: 8px;
        max-height: calc(100vh - 240px);
        overflow-y: auto;
    }

    .xkCategoryItem {
        width: 30%;
        flex-basis: calc(33.33% - 20px);
        height: 44px;
        position: relative;
    }

    .xkCategoryLoadingText {
        color: #FB5D5C;
        font-size: 12px;
        white-space: nowrap;
    }

    .xkLoadingMask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10000;
    }

    .xkLoadingCard {
        background: #fff;
        border-radius: 12px;
        padding: 40px 48px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    }

    .xkLoadingSpinner {
        width: 36px;
        height: 36px;
        border: 3px solid #F5F6F6;
        border-top-color: #FB5D5C;
        border-radius: 50%;
        animation: xkSpin 0.7s linear infinite;
    }

    @keyframes xkSpin {
        to { transform: rotate(360deg); }
    }

    .xkLoadingText {
        margin-top: 16px;
        color: #3C3C3C;
        font-size: 14px;
    }

    .xkLoadingSub {
        margin-top: 6px;
        color: #999;
        font-size: 12px;
    }

    .xkProductAddBtn {
        display: flex;
        align-items: center;
        color: #4A90E2;
        font-size: 16px;
        margin-bottom: 16px;
        cursor: pointer;
    }

    .xkProductAddBtn img {
        width: 19px;
        height: 19px;
        margin-right: 8px;
    }

    .xkProductAddInputP {
        margin-bottom: 16px;
    }

    .xkProductAddInputP .xkInput {
        width: 100%;
    }

    .xkProductList {
        display: flex;
        flex-direction: column;
    }

    .xkProductEmpty {
        color: #999;
        font-size: 14px;
        text-align: center;
        padding: 40px 0;
    }

    .xkProductItem {
        width: 100%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #E5E5E5;
        background-color: #F5F6F6;
        display: flex;
        align-items: center;
        padding: 0 12px;
        color: #3C3C3C;
        font-size: 14px;
        margin-bottom: 8px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .xkProductItemSel {
        border-color: #FB5D5C;
        background-color: #FFF6F6;
        color: #FB5D5C;
    }

    .xkProductItem div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .xkTeamList {
        display: flex;
        flex-wrap: wrap;
    }

    .huashuListItemDetailNoTitle {
        /*    padding-left: 23px;*/
        position: relative;
    }

    /*.huashuListItemDetailNoTitle::before{
    content: "";
    float: left;
    background-image: url("https://imagessl.edujia.com/A-1ed71af7_20230804141713.png");
    background-repeat: no-repeat;
    background-size: 23px 14px;
    width: 23px;
    height: 14px;
}
*/
    .imgTmp {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 0;
        top: 0;
    }

    .header-main-top {
        width: 32px;
        height: 32px;
        border-radius: 32px;
        margin-right: 14px;
        object-fit: cover;
    }

    .bottomBarP{
        width: 100%;
        height: 40px;
        /* overflow-x: scroll; */
        overflow-x: auto;
        overflow-y: hidden;
        z-index: 999;  
        position: absolute;
        left: 0;
        bottom: 0;     
    }

    .bottomBar {
        width: 100%;
        min-width: 320px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;
    }

    .bottomBarL{
        display: flex;
        align-items: center;
    }

    .addTypeBtn {
        width: 86px;
        height: 40px;
        display: flex;
        align-items: center;
        margin-left: 8px;
    }

    .addTypeBtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }

    .addTypeBtn div {
        font-size: 14px;
        color: #4A90E2;
        line-height: 16px;
    }

    .addHuashuBtn {
        height: 40px;
        display: flex;
        align-items: center;
    }

    .addHuashuBtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }

    .addHuashuBtn div {
        font-size: 14px;
        color: #4A90E2;
        line-height: 16px;
    }

    .psLbl {
        /* position: absolute;
        right: 16px;
        top: 12px; */
        font-size: 12px;
        color: #808080;
        line-height: 20px;
        margin-right: 16px;
    }

    .sizeBtn {
        width: 6px;
        border-radius: 7px;
        height: 50px;
        /*    background-color: red;*/
        display: flex;
        justify-content: space-evenly;
        pointer-events: none;
    }

    .sizeBtn div {
        width: 1px;
        height: 50px;
        background-color: lightgray;
    }

    .custom-resizer {
        width: 100%;
    }

    .layout-v>.multipane-resizer {
        width: 14px;
        height: 100%;
        margin-left: 0px;
        left: 0px;
        cursor: col-resize;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 10px;
        background-color: #fff;
        /*    border-left: 1px solid #eee;
    border-right: 1px solid #eee;*/
    }

    .searchArea {
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 150px;
    }

    .searchAreaBar {
        width: 79.5%;
        height: 32px;
        background-color: #F5F6F6;
        display: flex;
        align-items: center;
        margin-left: 16px;
        margin-right: 8px;
        border-radius: 4px;
    }

    .searchAreaBar img {
        width: 14px;
        height: 14px;
        margin-left: 12px;
        margin-right: 8px;
    }

    .searchAreaBar input {
        width: 90%;
        padding-right: 12px;
        height: 18px;
        border: none;
        font-size: 13px;
        background-color: transparent;
    }

    .searchAreaBtn {
        width: 88px;
        height: 32px;
        background-color: #FB5D5C;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 13px;
        border-radius: 4px;
        margin-right: 16px;
    }

    .searchAreaCancelBtn {
        border: 1px solid #FB5D5C;
        background-color: #FFF6F6;
        color: #FB5D5C;
    }

    .importHuashuBtn {
        height: 40px;
        display: flex;
        align-items: center;
        color: #4A90E2;
        font-size: 14px;
    }

    .importHuashuBtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
        margin-left: 16px;
    }

    .topBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 32px;
        background-color: #EEEEEE;
        position: absolute;
        top: 0;
        width: 100%;
        left: 0;
        z-index: 999;
        /* box-shadow:1px 1px 5px 1px #dedede; */
    }

    .topBarL {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #3C3C3C;
        font-size: 13px;
        white-space: nowrap;
    }

    .topBarL img {
        width: 14px;
        height: 14px;
        margin-left: 9px;
        margin-right: 8px;
    }

    .topBarR {
        width: 15px;
        height: 14px;
        margin-right: 15px;
    }

    .chooseHuashuTypeList {
        max-height: 300px;
        overflow: scroll;
    }

    .searchingBar{
        position: absolute;
        left: 0;
        top: 100px;
        display: flex;
        align-items: center;
        margin-top: 20px;
        z-index: 999;
        width: 100%;
        background-color: #fff;
        padding-top: 16px;
    }

    .searchingBarIcon{
        width: 54px;
        height: 22px;
        margin-left: 8px;
        margin-right: 4px;
    }

    .faceBtn{
        margin-right: 8px;
        color: #4A90E2;
        display: flex;
        align-items: center;
    }
    
    .faceBtnlbl{
        margin-left: 2px;
        margin-top: -3px;
    }

    .searchBackBtn{
        width: 25px;
        height: 25px;
        margin-left: 20px;
    }

    .sortTypeDialog {
        border-radius: 8px;
    }

    .sortDialogHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .sortDialogTitle {
        font-size: 16px;
        font-weight: bold;
        color: #3C3C3C;
    }

    .sortDialogSaveBtn {
        background-color: #FB5D5C;
        color: #fff;
        border: none;
        border-radius: 16px;
        padding: 4px 16px;
        font-size: 14px;
        cursor: pointer;
        margin-right: 24px;
    }

    .sortTypeList {
        display: flex;
        flex-wrap: wrap;
    }

    .sortTypeItem {
        width: 33%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #E5E5E5;
        background-color: #F5F6F6;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #3C3C3C;
        font-size: 14px;
        flex-basis: calc(33.33% - 20px);
        margin: 10px;
        box-sizing: border-box;
        cursor: grab;
    }

    .sortTypeItem div {
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 80%;
        overflow: hidden;
        text-align: center;
    }

    .sortTypeItemDragging {
        border-color: #FB5D5C;
        background-color: #FFF6F6;
        color: #FB5D5C;
        opacity: 0.8;
    }

    .sortTypeItemDragOver {
        border-color: #FB5D5C;
        border-style: dashed;
    }

    .sort-flip-move {
        transition: transform 0.3s ease;
    }

    .sortDialogFooter {
        display: none;
    }
</style>
